<template>
  <div class="SADashboardAnalytics">
    <div class="navbar">
      <NavBar></NavBar>
    </div>

    <div class="sideBarSection">
      <div class="FilterForDesktopView" id="scroll">
        <div class="post-login">
          <div class="filter-section-title">
            <div>
              <span class="border-bottom relative">Filters</span>
            </div>
            <span class="input-label-gray cursor-pointer" @click="resetFilter()">reset all</span>
          </div>

          <div class="filter-section" v-if="selectedOption === 'equity'">
            <!-- Market Participants -->
            <div class="filter-toggle-content" :class="{
              'active-menu-bgColor':
                active_index_title === 'Market Participants',
            }">
              <div class="filter-title" @click="toggleFilterSection('Market Participants')">
                Market Participants
                <i v-if="active_index_title === 'Market Participants'" class="el-icon-minus"></i>
                <i v-else class="el-icon-plus"></i>
              </div>

              <div v-if="active_index_title === 'Market Participants'">
                <!-- Expert search dropdown -->
                <el-select v-model="selectedExpert" class="top-margin-10 width-100"
                  placeholder="Search Expert E.g. Motilal Oswal" size="small" clearable filterable remote
                  reserve-keyword :remote-method="searchExperts" :loading="isExpertLoading"
                  @change="handleExpertSelection">
                  <!-- Display expert full name directly -->
                  <el-option v-for="expert in expertOptions" :key="expert.id" :label="expert.full_name"
                    :value="expert.id">
                    {{ expert.full_name }}
                  </el-option>
                </el-select>

                <!-- Checkbox group for market participants -->
                <!-- <el-checkbox-group v-model="marketParticipants">
                  <el-checkbox class="filter-tab" label="Financial Advisor"></el-checkbox>
                  <el-checkbox class="filter-tab" label="Analyst"></el-checkbox>
                </el-checkbox-group> -->
              </div>
            </div>

            <!-- Recommendation Type -->
            <div class="filter-toggle-content" :class="{
              'active-menu-bgColor':
                active_index_title === 'Recommendation Type',
            }">
              <div class="filter-title" @click="toggleFilterSection('Recommendation Type')">
                Recommendation Type
                <i v-if="active_index_title === 'Recommendation Type'" class="el-icon-minus"></i>
                <i v-else class="el-icon-plus"></i>
              </div>

              <div v-if="active_index_title === 'Recommendation Type'">
                <el-checkbox-group v-model="recommendationType">
                  <el-checkbox class="filter-tab" label="Buy"></el-checkbox>
                  <el-checkbox class="filter-tab" label="Sell"></el-checkbox>
                </el-checkbox-group>
              </div>
            </div>

            <!-- Market Cap -->
            <div class="filter-toggle-content" :class="{
              'active-menu-bgColor': active_index_title === 'Market Cap',
            }">
              <div class="filter-title" @click="toggleFilterSection('Market Cap')">
                Market Cap
                <i v-if="active_index_title === 'Market Cap'" class="el-icon-minus"></i>
                <i v-else class="el-icon-plus"></i>
              </div>

              <div v-if="active_index_title === 'Market Cap'">
                <el-checkbox-group v-model="marketCap">
                  <el-checkbox class="filter-tab" label="Large Cap"></el-checkbox>
                  <el-checkbox class="filter-tab" label="Mid Cap"></el-checkbox>
                  <el-checkbox class="filter-tab" label="Small Cap"></el-checkbox>
                </el-checkbox-group>
              </div>
            </div>

            <!-- Sector -->
            <div class="filter-toggle-content" :class="{
              'active-menu-bgColor': active_index_title === 'Sector',
            }">
              <div class="filter-title" @click="toggleFilterSection('Sector')">
                Sector
                <i v-if="active_index_title === 'Sector'" class="el-icon-minus"></i>
                <i v-else class="el-icon-plus"></i>
              </div>

              <div v-if="active_index_title === 'Sector'">
                <el-select class="top-margin-10 width-100" v-model="selectedSector" placeholder="Select Sector"
                  size="small" clearable @change="getSectorAndRecommendations">
                  <el-option v-for="sector in sectors" :key="sector.number" :label="sector.sector"
                    :value="String(sector.number)"></el-option>
                </el-select>
              </div>
            </div>
            <!-- Recommendation Status -->
            <div class="filter-toggle-content" :class="{
              'active-menu-bgColor':
                active_index_title === 'Recommendation Status',
            }">
              <div class="filter-title" @click="toggleFilterSection('Recommendation Status')">
                Recommendation Status
                <i v-if="active_index_title === 'Recommendation Status'" class="el-icon-minus"></i>
                <i v-else class="el-icon-plus"></i>
              </div>

              <div v-if="active_index_title === 'Recommendation Status'">
                <el-checkbox-group v-model="recommendationStatus">
                  <el-checkbox class="filter-tab" label="Live"></el-checkbox>
                  <el-checkbox class="filter-tab" label="Updated"></el-checkbox>
                  <el-checkbox class="filter-tab" label="Yet to live"></el-checkbox>
                  <el-checkbox class="filter-tab" label="Target achieved"></el-checkbox>
                  <el-checkbox class="filter-tab" label="Target not achieved"></el-checkbox>
                  <el-checkbox class="filter-tab" label="Stop loss triggered"></el-checkbox>
                </el-checkbox-group>
              </div>
            </div>

            <!-- Target Period -->
            <div class="filter-toggle-content" :class="{
              'active-menu-bgColor': active_index_title === 'Target Period',
            }">
              <div class="filter-title" @click="toggleFilterSection('Target Period')">
                Target Period
                <i v-if="active_index_title === 'Target Period'" class="el-icon-minus"></i>
                <i v-else class="el-icon-plus"></i>
              </div>

              <div v-if="active_index_title === 'Target Period'">
                <el-select class="top-margin-10 width-100" placeholder="Select" size="small" clearable
                  v-model="targetPeriodType" @change="onTargetPeriodChange">
                  <el-option label="Intraday" value="IntraDay"></el-option>
                  <el-option label="Short Term" value="Short Term"></el-option>
                  <el-option label="Mid Term" value="Mid Term"></el-option>
                  <el-option label="Long Term" value="Long_term"></el-option>
                </el-select>

                <!-- Short Term Period -->
                <div v-if="targetPeriodType === 'Short Term'">
                  <div>
                    <el-checkbox class="filter-tab" label="Week" v-model="selectedTargetPeriod"
                      :true-label="'Week'"></el-checkbox>
                  </div>
                  <div>
                    <el-checkbox class="filter-tab" label="Month" v-model="selectedTargetPeriod"
                      :true-label="'Month'"></el-checkbox>
                  </div>
                </div>

                <!-- Mid Term Period -->
                <div v-if="targetPeriodType === 'Mid Term'">
                  <div>
                    <el-checkbox class="filter-tab" label="Quarter" v-model="selectedTargetPeriod"
                      :true-label="'Quarter'"></el-checkbox>
                  </div>
                </div>

                <!-- Long Term Period -->
                <div v-if="targetPeriodType === 'Long_term'">
                  <div>
                    <el-checkbox class="filter-tab" label="Long Term" v-model="selectedTargetPeriod"
                      :true-label="'Long_term'"></el-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Filters for options -->
          <div class="filter-section" v-if="selectedOption === 'options'">
            <div class="filter-toggle-content" :class="{
              'active-menu-bgColor': active_index_title === 'Market Experts',
            }">
              <div class="filter-title" @click="toggleFilterSection('Market Experts')">
                Market Experts
                <i v-if="active_index_title === 'Market Experts'" class="el-icon-minus"></i>
                <i v-else class="el-icon-plus"></i>
              </div>

              <div v-if="active_index_title === 'Market Experts'">
                <el-select v-model="selectedExpert" class="top-margin-10 width-100"
                  placeholder="Search Expert E.g. Motilal Oswal" size="small" clearable filterable remote
                  reserve-keyword :remote-method="searchExperts" :loading="isExpertLoading"
                  @change="handleExpertSelection">
                  <el-option v-for="expert in expertOptions" :key="expert.id" :label="expert.full_name"
                    :value="expert.id">
                    {{ expert.full_name }}
                  </el-option>
                </el-select>

                <!-- <el-checkbox-group v-model="marketExperts">
                  <el-checkbox class="filter-tab" label="Financial Advisor"></el-checkbox>
                  <el-checkbox class="filter-tab" label="Analyst"></el-checkbox>
                </el-checkbox-group> -->
              </div>
            </div>

            <!-- Recommendation Type -->
            <div class="filter-toggle-content" :class="{
              'active-menu-bgColor': active_index_title === 'Strategy Type',
            }">
              <div class="filter-title" @click="toggleFilterSection('Strategy Type')">
                Strategy Type
                <i v-if="active_index_title === 'Strategy Type'" class="el-icon-minus"></i>
                <i v-else class="el-icon-plus"></i>
              </div>

              <div v-if="active_index_title === 'Strategy Type'">
                <el-checkbox-group v-model="strategyType">
                  <el-checkbox class="filter-tab" label="Bearish"></el-checkbox>
                  <el-checkbox class="filter-tab" label="Bullish"></el-checkbox>
                </el-checkbox-group>
              </div>
            </div>

            <!-- Strategy Status -->
            <div class="filter-toggle-content" :class="{
              'active-menu-bgColor': active_index_title === 'Strategy Status',
            }">
              <div class="filter-title" @click="toggleFilterSection('Strategy Status')">
                Strategy Status
                <i v-if="active_index_title === 'Strategy Status'" class="el-icon-minus"></i>
                <i v-else class="el-icon-plus"></i>
              </div>

              <div v-if="active_index_title === 'Strategy Status'">
                <el-checkbox-group v-model="strategyStatus">
                  <el-checkbox class="filter-tab" label="Live"></el-checkbox>
                  <el-checkbox class="filter-tab" label="Updated"></el-checkbox>
                  <el-checkbox class="filter-tab" label="Yet to live"></el-checkbox>
                  <el-checkbox class="filter-tab" label="Target achieved"></el-checkbox>
                  <el-checkbox class="filter-tab" label="Target not achieved"></el-checkbox>
                  <el-checkbox class="filter-tab" label="Stop loss triggered"></el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="market-type-dropdown">
      <div v-if="selectedOption === 'equity'" class="date-filter-section">
        <!-- <div class="input-container" style="margin-bottom: 10px;">
          <input type="text" placeholder="Search Company eg. Infosys" v-model="input2" class="search-input" />
        </div> -->

        <!-- Filter and Export Button Row -->
        <div class="filters" style="margin-right: 20px;">
          <div class="input-label-bold-gray">Select Duration:</div>
          <div class="flex">
            <el-date-picker v-model="from" type="date" placeholder="Start Date"
              style="width: 130px; margin-right: 18px;" size="mini" class="custom-date-picker"
              :default-value="defaultStartDate" :picker-options="startDatePickerOptions" />

            <el-date-picker v-model="to" type="date" placeholder="End Date" style="width: 130px; margin-right: 18px;"
              size="mini" class="custom-date-picker" :default-value="defaultEndDate"
              :picker-options="endDatePickerOptions" />
          </div>
        </div>
        <div class="flex">
          <div>
            <div class="input-label-bold-gray"> &nbsp;</div>
            <el-button size="mini" @click="clearEquityFilters" class="reset-btn" :disabled="!isEquityFilterActive()">
              Reset
            </el-button>
          </div>

          <!-- Right: Export Button -->
          <div>
            <div class="input-label-bold-gray"> &nbsp;</div>
            <el-button class="download-btn export-btn flex-center" @click="getEquityRecommendationsForExport"
              :disabled="is_export_Loading" :loading="is_export_Loading">
              Export
              <i class="el-icon-document" style="margin-left: 3px;"></i>
            </el-button>
          </div>
        </div>
      </div>

      <div v-if="selectedOption === 'options'" class="date-filter-section">
        <!-- <div class="input-container">
          <input type="text" placeholder="Search Company E.g. Bank Nifty" v-model="input2" class="search-input" />
          <span class="search-icon">
            <i class="el-icon-search"></i>
          </span>
        </div> -->

        <div class="filters">
          <div class="input-label-bold-gray">
            Select Duration:
          </div>
          <div class="flex">
            <el-date-picker v-model="start_date" type="date" placeholder="Start Date"
              style="width: 130px; margin-right: 18px;" size="mini" class="custom-date-picker"
              :default-value="defaultOptionsStartDate" :picker-options="optionsStartDatePickerOptions" />
            <el-date-picker v-model="end_date" type="date" placeholder="End Date"
              style="width: 130px; margin-right: 18px;" size="mini" class="custom-date-picker"
              :default-value="defaultOptionsEndDate" :picker-options="optionsEndDatePickerOptions" />
          </div>
        </div>
        <div class="flex">
          <div>
            <div class="input-label-bold-gray"> &nbsp;</div>
            <el-button size="mini" @click="clearOptionsFilters" class="reset-btn" :disabled="!isOptionsFilterActive()">
              Reset
            </el-button>
          </div>

          <div>
            <div class="input-label-bold-gray"> &nbsp;</div>
            <el-button class="download-btn export-btn flex-center" @click="getOptionsRecommendationsForExport"
              :disabled="is_options_export_loading" :loading="is_options_export_loading">
              Export
              <i class="el-icon-document" style="margin-left: 3px;"></i>
            </el-button>
          </div>
        </div>

      </div>
      <div>
        <div class="input-label-bold-gray"> &nbsp;</div>
        <el-select v-model="selectedOption" placeholder="Select" class="menu-links active-menu-link custom-dropdown"
          style="float:right; margin-right:10px; width:110px; border-radius:20px" size="mini" append-to-body
          @change="handleSelectionChange">
          <el-option label="EQUITY" value="equity"></el-option>
          <el-option label="OPTIONS" value="options"></el-option>
        </el-select>
      </div>
    </div>

    <div class="cover-page-container">


      <div v-if="selectedOption === 'equity'">
        <!-- Equity Table Content -->
        <div v-if="subscribedUsersList.length || is_user_list_loading" v-loading="is_user_list_loading">
          <div class="board-table-outer">
            <table class="outer-board-table board-table">
              <thead>
                <tr class="main-head">
                  <th
                    style="min-width: 70px; white-space: normal; position: sticky; left: 0; z-index: 2; background-color: #fff;">
                    Reco Date
                  </th>
                  <th
                    style="min-width: 180px; white-space: normal; position: sticky; left: 0; z-index: 2; background-color: #fff;">
                    Stock name
                  </th>
                  <th style="min-width: 85px; white-space: normal;">
                    Status
                  </th>
                  <th style="min-width: 70px; white-space: normal;">Entry</th>
                  <th style="min-width: 100px; white-space: normal;">
                    Performance
                  </th>
                  <th style="min-width: 70px; white-space: normal;">CMP</th>
                  <th style="min-width: 170px; white-space: normal;">
                    <span style="display: flex; align-items: center;">
                      Remaining Target
                      <img class="info-Logo cursor-pointer" src="../assets/images/Info.svg"
                        style="height: 12px; margin-left: 5px; cursor:none" alt="Info" />
                    </span>
                  </th>
                  <th style="min-width: 90px; white-space: normal;">Target</th>
                  <th style="min-width: 70px; white-space: normal;">
                    SL
                  </th>

                  <th style=" white-space: normal;">
                    Risk
                  </th>
                  <th style="white-space: nowrap;">
                    Expert
                  </th>
                  <th style="min-width: 50px; white-space: normal; cursor: pointer;" class="fixed-column">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in subscribedUsersList" :key="index"
                  @contextmenu.prevent="openContextMenu($event, data)">
                  <td style="position: sticky; left: 0; z-index: 2; background-color: #fff;">
                    <span style="font-size: 11px; font-weight: 600; line-height:13px">
                      {{
                        data.created_at
                          ? moment(data.created_at).format("MMM DD YYYY")
                          : "--"
                      }}
                    </span>
                    <br />
                    <span style="font-size: 11px; font-weight: 500; color: #000000; line-height:13px">
                      {{
                        data.created_at
                          ? moment(data.created_at).format("h:mm A")
                          : ""
                      }}
                    </span>
                  </td>

                  <td style="position: sticky; left: 0; z-index: 2; background-color: #fff;">
                    <span style="font-size: 12px; font-weight: 600; line-height:16px; margin-bottom: 10px;">
                      {{ data.stock.name || "NA" }}
                    </span>
                    <!-- "Buy" Label -->
                    <span class="tags" :style="{
                      fontSize: '10px',
                      fontWeight: '600',
                      lineHeight: '16px',
                      padding: '2px 10px',
                      color: 'white',
                      backgroundColor:
                        data.reco === 'Buy'
                          ? '#0BA042'
                          : data.reco === 'Sell'
                            ? '#EA2526'
                            : '#000000', // Default color for other cases
                      marginRight: '5px',
                      marginBottom: '10px',
                    }">
                      {{ data.reco || "NA" }}
                    </span>
                    <span style="display: inline-flex; align-items: center;">
                      <!-- <img
                        class="info-Logo cursor-pointer"
                        src="../assets/images/Duration.svg"
                        style="height: 12px; margin-right: 5px;"
                        alt="Info"
                      /> -->
                      ({{ data.duration || "NA" }})
                    </span>
                  </td>

                  <td>
                    <div :style="{
                      fontSize: '12px',
                      fontWeight: '500',
                      color:
                        data.reco_status === 'LIVE' ? '#0BA042' : '#000000',
                    }">
                      {{ data.reco_status }}
                    </div>
                  </td>

                  <td>
                    <span style="font-size: 12px; font-weight: 500; line-height:13px">
                      <span v-if="data.reco_open_price">₹{{ data.reco_open_price }}</span>
                      <span v-else>NA</span>
                    </span>

                    <!-- Timestamp -->
                    <br />
                    <span style="font-size: 9px; font-weight: 500; line-height:13px; color:#969696">
                      {{
                        data.created_at
                          ? moment(data.created_at).format("MMM DD YYYY")
                          : "NA"
                      }}
                    </span>
                    <br />
                    <span style="font-size: 9px; font-weight: 500; line-height:13px; color:#969696">
                      {{
                        data.created_at
                          ? moment(data.created_at).format("h:mm A")
                          : ""
                      }}
                    </span>
                  </td>

                  <td style="font-size: 12px; font-weight: 500">
                    {{ data.performance ? data.performance + "%" : "NA" }}
                  </td>

                  <td>
                    <span style="font-size: 12px; font-weight: 500; line-height: 13px">
                      <span v-if="data.stock.current_price">₹{{ data.stock.current_price }}</span>
                      <span v-else>NA</span>
                    </span>

                    <br />
                    <span style="font-size: 9px; font-weight: 500; line-height:13px">
                      {{
                        data.stock.current_datetime
                          ? moment(data.stock.current_datetime).format(
                            "MMM DD YYYY"
                          )
                          : "NA"
                      }}
                    </span>
                    <br />
                    <span style="font-size: 9px; font-weight: 500; color: #000000; line-height:13px">
                      {{
                        data.stock.current_datetime
                          ? moment(data.stock.current_datetime).format("h:mm A")
                          : ""
                      }}
                    </span>
                  </td>
                  <td>
                    <!-- Stock Name -->
                    <!-- <span
                      style="font-size: 14px; font-weight: 700; line-height: 13px; color: #0BA042"
                    >
                      <span
                        v-if="data.target_price && data.stock.current_price"
                      >
                        ₹{{
                          (
                            data.target_price - data.stock.current_price
                          ).toFixed(2)
                        }}
                      </span>
                      <span v-else>NA</span>
                    </span> -->

                    <span style="font-size: 14px; font-weight: 700; color:#0BA042">
                      {{
                        data.potential_as_of_current_date
                          ? data.potential_as_of_current_date.toFixed(2) + "%"
                          : "NA"
                      }}
                    </span>

                    <!-- Timestamp -->
                    <br />
                    <span style="font-size: 9px; font-weight: 500; color:#969696">
                      As On
                      {{
                        data.stock.current_datetime
                          ? moment(data.stock.current_datetime).format(
                            "MMM DD YYYY"
                          )
                          : "NA"
                      }}
                    </span>
                    <br />
                    <span style="font-size: 9px; font-weight: 500; color:#969696">
                      ({{ moment().diff(moment(data.created_at), "days") }} Days
                      from reco date)
                    </span>
                  </td>

                  <td>
                    <!-- Stock Name -->
                    <span style="font-size: 12px; font-weight: 500; line-height: 13px; color: #000000">
                      <span v-if="data.target_price">₹ {{ data.target_price }}</span>
                      <span v-else>NA</span>
                    </span>

                    <!-- "Buy" Label -->
                    <br />
                    <span style="font-size: 10px; font-weight: 600; line-height: 13px; color: #0BA042">
                      {{
                        data.target_potential
                          ? data.target_potential + "%"
                          : "NA"
                      }}
                    </span>
                    <br />
                    <span style="font-size: 9px; font-weight: 500; line-height:13px; color:#969696">
                      {{
                        data.created_at
                          ? moment(data.created_at).format("MMM DD YYYY")
                          : "NA"
                      }}
                    </span>
                  </td>
                  <td>
                    <!-- Stock Name -->
                    <span style="font-size: 12px; font-weight: 600; line-height: 13px; color: #EA2526">
                      <span v-if="data.stop_loss">₹ {{ data.stop_loss }}</span>
                      <span v-else>NA</span>
                    </span>

                    <!-- Timestamp -->
                    <br />
                    <div v-if="data.reco_status === 'STOP LOSS TRIGGERED'">
                      <span style="font-size: 9px; font-weight: 500; line-height: 13px">
                        {{
                          data.created_at
                            ? moment(data.created_at).format("MMM DD YYYY")
                            : "NA"
                        }}
                      </span>
                      <br />
                      <span style="font-size: 9px; font-weight: 500; color: #000000; line-height: 13px">
                        {{
                          data.created_at
                            ? moment(data.created_at).format("h:mm A")
                            : ""
                        }}
                      </span>
                    </div>
                  </td>

                  <td>
                    <div style="border-radius: 15px; padding: 5px 0px;">
                      <span :style="[
                        data.risk_tag == 'low_risk'
                          ? { backgroundColor: '#ECFFF3', color: '#0BA042' } // text color for low_risk
                          : data.risk_tag == 'moderate_risk'
                            ? { backgroundColor: '#FFF6E6', color: '#EDB21A' } // text color for moderate_risk
                            : data.risk_tag == 'high_risk'
                              ? { backgroundColor: '#FFF1F1', color: '#EA2526' } // text color for high_risk
                              : { backgroundColor: '#FFF6E6', color: '#EDB21A' }, // Default text color for moderate_risk
                        {
                          textTransform: 'capitalize',
                          whiteSpace: 'nowrap',
                          borderRadius: '5px',
                          padding: '5px 10px',
                        },
                      ]">
                        {{
                          data.risk_tag
                            ? data.risk_tag
                              .replace("_risk", "")
                              .replace(/_/g, " ")
                            : "NA"
                        }}
                      </span>
                    </div>
                  </td>

                  <td style="font-size: 12px; font-weight: 600; white-space: nowrap;">
                    <div class="expert-name" style="display: flex; align-items: center;">
                      {{ data.user.full_name || "NA" }}
                      <img class="info-Logo cursor-pointer" src="../assets/images/verify.svg"
                        style="width: 12px; margin-left: 5px; cursor:none" alt="Verified" />
                    </div>
                    <br />
                    <span style="font-size: 11px; font-weight: 600; color:#969696">
                      SEBI No. {{ data.user.sebi_regi_number || "NA" }}
                    </span>
                  </td>

                  <td class="fixed-column">
                    <div class="actions" style="display:flex;">
                      <el-popover trigger="click" placement="bottom-start" popper-class="custom-popover">
                        <div class="popover-content">
                          <div class="popover-item" @click="copyForWhatsApp(data)"
                            style="border-bottom: 1px solid #e0e0e0; display: flex; align-items: center;padding:5px; cursor:pointer">
                            <img src="../assets/images/whatsapp 3.svg" alt="WhatsApp"
                              style="width: 16px; height: 16px; margin-right: 8px;" />
                            Copy for WhatsApp
                          </div>
                          <div class="popover-divider"></div>
                          <div class="popover-item" @click="copyForTelegram(data)"
                            style="display: flex; align-items: center; padding:5px; cursor:pointer">
                            <img src="../assets/images/telegram 3.svg" alt="Telegram"
                              style="width: 16px; height: 16px; margin-right: 8px;" />
                            Copy for Telegram
                          </div>
                          <div class="popover-divider"></div>
                          <div class="popover-item" @click="openTelegramDialog(data)"
                            style="display:flex;align-items:center;padding:5px;cursor:pointer">
                            <img src="../assets/images/telegram 3.svg" alt="Telegram"
                              style="width:16px; height:16px; margin-right:8px;" />
                            Telegram
                          </div>

                        </div>
                        <span slot="reference">
                          <img src="../assets/images/Share (1).svg" alt="Share" style="cursor: pointer;" />
                        </span>
                      </el-popover>
                      <div v-if="isStockAntsAdmin" style="margin-left:20px;">
                        <i class="el-icon-delete" style="color: red; cursor: pointer; font-size: 20px;"
                          @click="deleteReco(data)"></i>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- Context Menu -->
            <div v-if="contextMenu.visible && isStockAntsAdmin"
              :style="{ top: contextMenu.y + 'px', left: contextMenu.x + 'px' }" class="context-menu">
              <ul>
                <li @click="openEditPopup">Edit Reco</li>
              </ul>
            </div>

            <!-- Telegram groups list dialog -->
            <el-dialog :visible.sync="telegramDialogVisible" :close-on-click-modal="true" :close-on-press-escape="true"
              :lock-scroll="true" class="telegram-broker-dialog">
              <div class="broker-card-main" v-loading="loadingBrokers">

                <!-- stockants Logo -->
                <img class="logo" src="../assets/stockantsLogo.png" alt="StockAnts-logo" />

                <!-- Search -->
                <div class="search-broker-input" v-if="brokerList.length > 1">
                  <el-input v-model="brokerSearch" size="mini" clearable placeholder="Search your broker"
                    prefix-icon="el-icon-search" />
                </div>

                <!-- Brokers list -->
                <el-checkbox-group v-model="selectedBrokers" class="broker-card-outer">
                  <div class="broker-grid">
                    <label v-for="broker in filteredTelegramBrokers" :key="broker.id" class="broker-card"
                      :class="{ active: selectedBrokers.includes(broker.id) }">
                      <el-checkbox :label="broker.id" class="hidden-checkbox" />

                      <div class="broker-content">
                        <img class="broker-logo" :src="broker.logo" alt="broker" />
                        <div class="broker-title">{{ broker.title }}</div>
                      </div>
                    </label>
                  </div>
                </el-checkbox-group>

                <!-- Footer -->
                <div class="dialog-footer">
                  <el-button size="mini" @click="telegramDialogVisible = false">
                    Cancel
                  </el-button>
                  <el-button size="mini" type="primary" :disabled="!selectedBrokers.length"
                    @click="sendTelegramMessage">
                    Send
                  </el-button>
                </div>
              </div>
            </el-dialog>

            <el-dialog :visible.sync="editDialog.visible" title="Edit Recommendation" class="custom-dialog">
              <p class="reco-id">Reco ID: {{ editDialog.reco_id }}</p>

              <!-- Status Selection -->
              <el-select v-model="editDialog.status" placeholder="Select Status" class="status-select">
                <el-option v-for="status in recoStatusOptions" :key="status" :label="status"
                  :value="status"></el-option>
              </el-select>

              <div style="margin-top: 20px;">
                <h3 class="status-title">Status Details</h3>

                <div v-if="editDialog.status === 'LIVE'" class="status-row">
                  <span class="status-label">Live Trigger Date & Time</span>
                  <el-date-picker v-model="editDialog.liveTriggerDate" type="date" placeholder="Select Date" />
                  <el-time-picker v-model="editDialog.liveTriggerTime" placeholder="Select Time" />
                  <el-input v-model.number="editDialog.liveTriggerPrice" type="number" placeholder="Enter Price" />
                </div>

                <div v-if="editDialog.status === 'UPDATED'" class="status-row">
                  <span class="status-label">Updated Date & Time</span>
                  <el-date-picker v-model="editDialog.updatedDate" type="date" placeholder="Select Date" />
                  <el-time-picker v-model="editDialog.updatedTime" placeholder="Select Time" />
                  <el-input v-model.number="editDialog.updatedPrice" type="number" placeholder="Enter Price" />
                </div>

                <div v-if="editDialog.status === 'CLOSED'" class="status-row">
                  <span class="status-label">Closed Date & Time</span>
                  <el-date-picker v-model="editDialog.closedDate" type="date" placeholder="Select Date" />
                  <el-time-picker v-model="editDialog.closedTime" placeholder="Select Time" />
                  <el-input v-model.number="editDialog.closedPrice" type="number" placeholder="Enter Price" />
                </div>

                <div v-if="editDialog.status === 'TARGET ACHIEVED'" class="status-row">
                  <span class="status-label">Target Achieved Date & Time</span>
                  <el-date-picker v-model="editDialog.targetAchievedDate" type="date" placeholder="Select Date" />
                  <el-time-picker v-model="editDialog.targetAchievedTime" placeholder="Select Time" />
                  <el-input v-model.number="editDialog.targetAchievedPrice" type="number" placeholder="Enter Price" />
                </div>

                <div v-if="editDialog.status === 'TARGET NOT ACHIEVED'" class="status-row">
                  <span class="status-label">Target Not Achieved Date & Time</span>
                  <el-date-picker v-model="editDialog.targetNotAchievedDate" type="date" placeholder="Select Date" />
                  <el-time-picker v-model="editDialog.targetNotAchievedTime" placeholder="Select Time" />
                  <el-input v-model.number="editDialog.targetNotAchievedPrice" type="number"
                    placeholder="Enter Price" />
                </div>

                <div v-if="editDialog.status === 'YET TO LIVE'" class="status-row">
                  <span class="status-label">Yet to Live Date & Time</span>
                  <el-date-picker v-model="editDialog.yetToLiveDate" type="date" placeholder="Select Date" />
                  <el-time-picker v-model="editDialog.yetToLiveTime" placeholder="Select Time" />
                </div>

                <div v-if="editDialog.status === 'STOP LOSS TRIGGERED'" class="status-row">
                  <span class="status-label">Stop Loss Triggered Date & Time</span>
                  <el-date-picker v-model="editDialog.stopLossTriggeredDate" type="date" placeholder="Select Date" />
                  <el-time-picker v-model="editDialog.stopLossTriggeredTime" placeholder="Select Time" />
                  <el-input v-model.number="editDialog.stopLossTriggeredPrice" type="number"
                    placeholder="Enter Price" />
                </div>

                <div v-if="editDialog.status === 'EXIT'" class="status-row">
                  <span class="status-label">Exit Date & Time</span>
                  <el-date-picker v-model="editDialog.exitDate" type="date" placeholder="Select Date" />
                  <el-time-picker v-model="editDialog.exitTime" placeholder="Select Time" />
                  <el-input v-model.number="editDialog.exitPrice" type="number" placeholder="Enter Price" />
                </div>
              </div>

              <!-- Action Buttons -->
              <span slot="footer" class="dialog-footer">
                <el-button @click="editDialog.visible = false" class="cancel-btn">Cancel</el-button>
                <el-button type="primary" @click="saveUpdatedStatus" class="save-btn">Save</el-button>
              </span>
            </el-dialog>

          </div>

          <div class="pagination" style="text-align:center">
            <el-pagination @current-change="handleSubscribedUsersPageChange"
              :current-page="paginationSubscribedUsers.current_page" :page-sizes="[5, 10, 20, 50]"
              :page-size="paginationSubscribedUsers.page_size" :total="paginationSubscribedUsers.total_entries"
              :pager-count="5" layout="total, prev, pager, next"></el-pagination>
          </div>
        </div>
        <div v-if="!is_user_list_loading && !subscribedUsersList.length">
          <NoDataFound></NoDataFound>
        </div>
      </div>

      <div v-if="selectedOption === 'options'">
        <!-- Options Table Content -->
        <div v-if="brokersRecoList.length || is_broker_reco_list_loading" v-loading="is_broker_reco_list_loading">
          <div class="board-table-outer">
            <table class="outer-board-table board-table">
              <thead>
                <tr class="main-head">
                  <th
                    style="min-width: 80px; white-space: normal; position: sticky; left: 0; z-index: 2; background-color: #fff;">
                    Strategy ID
                  </th>
                  <th
                    style="min-width: 90px; white-space: normal; position: sticky; left: 0; z-index: 2; background-color: #fff;">
                    Strategy Date
                  </th>
                  <th
                    style="min-width: 190px; white-space: normal; position: sticky; left: 0; z-index: 2; background-color: #fff;">
                    Strategy Name
                  </th>
                  <th style="min-width: 85px; white-space: normal;">
                    Status
                  </th>
                  <th style="min-width: 80px; white-space: normal;">Entry</th>
                  <th style="min-width: 100px; white-space: normal;">
                    Performance
                  </th>
                  <th style="min-width: 70px; white-space: normal;">CMP</th>
                  <th style="min-width: 80px; white-space: normal;">Strike Price</th>
                  <th style="min-width: 170px; white-space: normal;">
                    <span style="display: flex; align-items: center;">
                      Remaining Target
                      <img class="info-Logo cursor-pointer" src="../assets/images/Info.svg"
                        style="height: 12px; margin-left: 5px; cursor:none" alt="Info" />
                    </span>
                  </th>
                  <th style="min-width: 130px; white-space: normal;">
                    Approx Capital Req.
                  </th>
                  <th style="min-width: 80px; white-space: normal;">Target</th>
                  <th style="min-width: 70px; white-space: normal;">
                    SL
                  </th>

                  <th style="white-space: normal;">
                    Risk
                  </th>
                  <th style="white-space: nowrap;">
                    Expert
                  </th>
                  <th style="min-width: 50px; white-space: normal; cursor: pointer;" class="fixed-column">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(data, index) in brokersRecoList">

                  <tr @contextmenu.prevent="openContextMenuOptions($event, data.legs_data[0], index)">
                    <td style="font-size: 12px; font-weight: 500; color:#000000;">
                      {{ data.id || "NA" }}
                    </td>
                    <!-- Date & Time -->
                    <td style="position: sticky; left: 0; z-index: 2; background-color: #fff;">
                      <span style="font-size: 11px; font-weight: 600; line-height:13px">
                        {{
                          data.created_date_str
                            ? moment(data.created_date_str).format("MMM DD YYYY")
                            : "NA"
                        }}
                      </span>
                      <br />
                      <span style="font-size: 11px; font-weight: 500; color: #000000; line-height:13px">
                        {{
                          data.created_date_str
                            ? moment(data.created_date_str).format("h:mm A")
                            : ""
                        }}
                      </span>
                    </td>

                    <!-- Title, Direction, Tags -->
                    <td style="width: 150px; white-space: normal; position: sticky; left: 0; z-index: 2; background-color: #fff;">
                      <span style="font-size: 12px; font-weight: 600; line-height:16px; margin-bottom: 10px;">
                        {{ data.title || "NA" }}
                      </span>
                      <span class="tags" :style="{
                        fontSize: '10px',
                        fontWeight: '600',
                        lineHeight: '16px',
                        padding: '2px 10px',
                        color: 'white',
                        backgroundColor:
                          data.legs_data[0].direction === 'BUY'
                            ? '#0BA042'
                            : data.legs_data[0].direction === 'SELL'
                              ? '#EA2526'
                              : '#000000',
                        marginRight: '5px',
                        marginBottom: '10px',
                      }">
                        {{ data.legs_data[0].direction || "NA" }}
                      </span>
                      <span :style="{
                        color:
                          data.tags === 'BULLISH'
                            ? '#0BA042'
                            : data.tags === 'BEARISH'
                              ? '#EA2526'
                              : 'black',
                      }">
                        {{ data.tags || "NA" }}
                      </span>
                      <span style="margin-left:5px;">
                        ({{ data.legs_data[0].stock_data.lot_size || "NA" }} Lot)
                      </span>

                      <!-- Collapse icon -->
                      <span v-if="data.legs_data.length > 1" @click="toggleAdvisory(index)"
                        style="cursor: pointer; font-size: 16px;">
                        {{ selectedAdvisoryIndex === index ? "▲" : "▼" }}
                      </span>
                    </td>

                    <!-- Status -->
                    <td>
                      <div :style="{
                        fontSize: '12px',
                        fontWeight: '500',
                        color: data.legs_data[0].status === 'LIVE' ? '#0BA042' : '#000000',
                      }">
                        {{
                          data.legs_data[0].status
                            ? data.legs_data[0].status.replace(/_/g, " ")
                            : "NA"
                        }}
                      </div>
                    </td>

                    <!-- Entry Premium -->
                    <td>
                      <span style="font-size: 12px; font-weight: 600; line-height:13px; color:#000000;">
                        ₹ {{ data.legs_data[0].entry_premium || "NA" }}
                      </span>
                      <br />
                      <span style="font-size: 9px; font-weight: 500; color: #969696; line-height:13px">
                        {{
                          data.created_date_str
                            ? moment(data.created_date_str).format("MMM DD YYYY")
                            : "NA"
                        }}
                      </span>
                      <br />
                      <span style="font-size: 9px; font-weight: 500; color: #969696; line-height:13px">
                        {{
                          data.created_date_str
                            ? moment(data.created_date_str).format("h:mm A")
                            : ""
                        }}
                      </span>
                    </td>

                    <!-- Performance -->
                    <td style="font-size: 12px; font-weight: 500; color:#000000;">
                      {{ data.legs_data[0].performance ? data.legs_data[0].performance + "%" : "NA" }}
                    </td>

                    <!-- Current Premium -->
                    <td>
                      <span style="font-size: 12px; font-weight: 500;">
                        ₹ {{ data.legs_data[0].stock_data.ltp || "NA" }}
                      </span>
                      <br />
                      <span style="font-size: 9px; font-weight: 500; color: #969696;">
                        {{
                          data.last_event_timestamp
                            ? moment(data.last_event_timestamp).format("MMM DD YYYY")
                            : "NA"
                        }}
                      </span>
                      <br />
                      <span style="font-size: 9px; font-weight: 500; color: #969696; line-height:13px">
                        {{
                          data.last_event_timestamp
                            ? moment(data.last_event_timestamp).format("h:mm A")
                            : ""
                        }}
                      </span>
                    </td>

                    <!-- Strike price -->
                    <td>
                      <span style="font-size: 12px; font-weight: 500;">
                        ₹ {{ data.legs_data[0].stock_data.strike || "NA" }}
                      </span>
                    </td>

                    <!-- Remaining Potential -->
                    <td>
                      <span style="font-size: 14px; font-weight: 700; line-height: 13px; color: #0BA042">
                        {{ data.legs_data[0] && data.legs_data[0].remaining_target_in_perc
                          ? data.legs_data[0].remaining_target_in_perc + "%"
                          : "NA" }}
                      </span>
                      <br />
                      <span style="font-size: 9px; font-weight: 500; color:#969696">
                        {{ data.wheel_date || "NA" }}
                      </span>
                    </td>

                    <!-- Required Margin -->
                    <td style="font-size: 12px; font-weight: 600; color:#000000;">
                      <span v-if="data.required_total_margin">₹ {{ data.required_total_margin }}</span>
                      <span v-else>NA</span>
                    </td>

                    <!-- Target Premium -->
                    <td>
                      <span style="font-size: 12px; font-weight: 500; color:#000000">
                        <span v-if="data.legs_data[0].target_premium">₹ {{ data.legs_data[0].target_premium }}</span>
                        <span v-else>NA</span>
                      </span>
                      <br />
                      <span style="font-size: 10px; font-weight: 600; line-height: 13px; color: #0BA042">
                        (
                        {{
                          data.legs_data[0].target_premium && data.legs_data[0].entry_premium
                            ? ((data.legs_data[0].target_premium / data.legs_data[0].entry_premium) * 100).toFixed(2) + "%"
                            : "NA"
                        }}
                        )
                      </span>
                    </td>

                    <td>
                      <!-- Stop Loss -->
                      <span style="font-size: 12px; font-weight: 600; line-height:13px; color:#EA2526">
                        <span v-if="data.legs_data && data.legs_data[0] && data.legs_data[0].stop_loss">
                          ₹ {{ data.legs_data[0].stop_loss }}
                        </span>
                        <span v-else>NA</span>
                      </span>

                      <!-- Timestamp (Only if Stoploss triggered) -->
                      <br />
                      <div
                        v-if="data.legs_data && data.legs_data[0] && data.legs_data[0].status === 'STOPLOSS_TRIGGERED'">
                        <span style="font-size: 9px; font-weight: 500; line-height: 13px">
                          {{
                            data.last_event_timestamp
                              ? moment(data.last_event_timestamp).format("MMM DD YYYY")
                              : "NA"
                          }}
                        </span>
                        <br />
                        <span style="font-size: 9px; font-weight: 500; color: #000000; line-height: 13px">
                          {{
                            data.last_event_timestamp
                              ? moment(data.last_event_timestamp).format("h:mm A")
                              : ""
                          }}
                        </span>
                      </div>
                    </td>

                    <td>
                      <div style="border-radius: 15px; padding: 5px 0px;">
                        <span :style="[
                          data.expert_detail && data.expert_detail.risk_category === 'Low'
                            ? { backgroundColor: '#ECFFF3', color: '#0BA042' }
                            : data.expert_detail && data.expert_detail.risk_category === 'Moderate'
                              ? { backgroundColor: '#FFF6E6', color: '#EDB21A' }
                              : data.expert_detail && data.expert_detail.risk_category === 'High'
                                ? { backgroundColor: '#FFF1F1', color: '#EA2526' }
                                : { backgroundColor: '#FFF6E6', color: '#EDB21A' },
                          {
                            textTransform: 'capitalize',
                            whiteSpace: 'nowrap',
                            borderRadius: '5px',
                            padding: '5px 10px',
                          },
                        ]">
                          {{
                            data.expert_detail && data.expert_detail.risk_category
                              ? data.expert_detail.risk_category
                              : "NA"
                          }}
                        </span>
                      </div>
                    </td>

                    <td style="font-size: 12px; font-weight: 600; white-space: nowrap;">
                      <div class="expert-name" style="display: flex; align-items: center;">
                        {{ data.expert_detail && data.expert_detail.full_name ? data.expert_detail.full_name : "NA" }}
                        <img v-if="data.expert_detail && data.expert_detail.mark_as_verified_user"
                          class="info-Logo cursor-pointer" src="../assets/images/verify.svg"
                          style="width: 12px; margin-left: 5px; cursor:none" alt="Verified" />
                      </div>
                      <br />
                      <span style="font-size: 10px; font-weight: 600; color:#969696">
                        SEBI No. {{ data.expert_detail && data.expert_detail.sebi_regi_number ?
                          data.expert_detail.sebi_regi_number : "NA" }}
                      </span>
                    </td>

                    <td class="fixed-column">
                      <div style="display: flex">
                        <el-popover trigger="click" placement="bottom-start" popper-class="custom-popover">
                          <div class="popover-content">
                            <div class="popover-item" @click="copyForWhatsAppOptions(data)"
                              style="border-bottom: 1px solid #e0e0e0; display: flex; align-items: center;padding:5px; cursor:pointer">
                              <img src="../assets/images/whatsapp 3.svg" alt="WhatsApp"
                                style="width: 16px; height: 16px; margin-right: 8px;" />
                              Copy for WhatsApp
                            </div>
                            <div class="popover-divider"></div>
                            <div class="popover-item" @click="copyForTelegramOptions(data)"
                              style="display: flex; align-items: center; padding:5px; cursor:pointer">
                              <img src="../assets/images/telegram 3.svg" alt="Telegram"
                                style="width: 16px; height: 16px; margin-right: 8px;" />
                              Copy for Telegram
                            </div>
                          </div>
                          <span slot="reference">
                            <img src="../assets/images/Share (1).svg" alt="Share"
                              style="cursor: pointer; padding-left:10px;" />
                          </span>
                        </el-popover>

                        <div v-if="isStockAntsAdmin" style="margin-left:20px;">
                          <i class="el-icon-delete" style="color: red; cursor: pointer; font-size: 20px;"
                            @click="deleteOptionStrategy(data)"></i>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <!-- Collapsible row for index 1 -->
                  <tr v-if="selectedAdvisoryIndex === index && data.legs_data && data.legs_data.length > 1"
                    @contextmenu.prevent="openContextMenuOptions($event, data.legs_data[1], index)">
                    <td colspan="13" class="sub-section">
                      <div class="table-padding">
                        <div class="inner-table">
                          <table class="board-table board-table-inner">
                            <tbody>
                              <tr>
                                <td
                                  style="min-width: 80px; position: sticky; left: 0; z-index: 2; background-color: #fff;">
                                </td>
                                <td
                                  style="min-width: 120px; position: sticky; left: 0; z-index: 2; background-color: #fff;">
                                </td>
                                <td
                                  style="min-width: 200px; position: sticky; left: 0; z-index: 2; background-color: #fff;">
                                  <span
                                    style="font-size: 12px; font-weight: 600; line-height:16px; margin-bottom: 10px;">
                                    {{ data.title ? data.title : "NA" }}
                                  </span>
                                  <!-- "Buy/Sell" Label -->
                                  <span class="tags" :style="{
                                    fontSize: '10px',
                                    fontWeight: '600',
                                    lineHeight: '16px',
                                    padding: '2px 10px',
                                    color: 'white',
                                    backgroundColor:
                                      data.legs_data[1].direction === 'BUY'
                                        ? '#0BA042'
                                        : data.legs_data[1].direction === 'SELL'
                                          ? '#EA2526'
                                          : '#000000',
                                    marginRight: '5px',
                                    marginBottom: '10px',
                                  }">
                                    {{ data.legs_data[1].direction || "NA" }}
                                  </span>
                                  <br />
                                  <span :style="{
                                    color:
                                      data.tags === 'BULLISH'
                                        ? '#0BA042'
                                        : data.tags === 'BEARISH'
                                          ? '#EA2526'
                                          : 'black',
                                  }">{{ data.tags || "NA" }}</span>
                                  <span style="margin-left:5px;">
                                    ({{ data.legs_data[1] &&
                                      data.legs_data[1].stock_data &&
                                      data.legs_data[1].stock_data.lot_size
                                      ? data.legs_data[1].stock_data.lot_size
                                      : "NA" }} Lot)
                                  </span>
                                </td>

                                <td style="min-width: 90px; white-space: normal;">
                                  <div :style="{
                                    fontSize: '12px',
                                    fontWeight: '500',
                                    color:
                                      data.legs_data[1].status === 'LIVE'
                                        ? '#0BA042'
                                        : '#000000',
                                  }">
                                    {{
                                      data.legs_data[1].status
                                        ? data.legs_data[1].status.replace(/_/g, " ")
                                        : "NA"
                                    }}
                                  </div>
                                </td>

                                <td style="min-width: 100px; white-space: normal;">
                                  <span style="font-size: 12px; font-weight: 600; line-height:13px; color:#000000;">
                                    ₹ {{ data.legs_data[1].entry_premium || "NA" }}
                                  </span>
                                  <br />
                                  <span style="font-size: 9px; font-weight: 500; color: #969696; line-height:13px">
                                    {{
                                      data.legs_data[1].created_date_str
                                        ? moment(data.legs_data[1].created_date_str).format("MMM DD YYYY")
                                        : "NA"
                                    }}
                                  </span>
                                  <br />
                                  <span style="font-size: 9px; font-weight: 500; color: #969696; line-height:13px">
                                    {{
                                      data.legs_data[1].created_date_str
                                        ? moment(data.legs_data[1].created_date_str).format("h:mm A")
                                        : ""
                                    }}
                                  </span>
                                </td>

                                <td style="min-width: 80px; font-size: 12px; font-weight: 500; color:#000000;">
                                  {{
                                    data.legs_data[1].performance
                                      ? data.legs_data[1].performance + "%"
                                      : "NA"
                                  }}
                                </td>

                                <td style="min-width: 40px; white-space: normal;">
                                  <span style="font-size: 12px; font-weight: 500;">
                                    ₹ {{ data.legs_data[1].stock_data && data.legs_data[1].stock_data.ltp ?
                                      data.legs_data[1].stock_data.ltp : "NA" }}
                                  </span>
                                  <br />
                                  <span style="font-size: 9px; font-weight: 500; color: #969696;">
                                    {{
                                      data.legs_data[1].status_change_timestamp_str
                                        ? moment(data.legs_data[1].status_change_timestamp_str).format("MMM DD YYYY")
                                        : "NA"
                                    }}
                                  </span>
                                  <br />
                                  <span style="font-size: 9px; font-weight: 500; color: #969696; line-height:13px">
                                    {{
                                      data.legs_data[1].status_change_timestamp_str
                                        ? moment(data.legs_data[1].status_change_timestamp_str).format("h:mm A")
                                        : ""
                                    }}
                                  </span>
                                </td>

                                <!-- Strike price -->
                                <td style="min-width: 100px; white-space: normal;">
                                  <span style="font-size: 12px; font-weight: 500;">
                                    ₹ {{ data.legs_data[1].stock_data.strike || "NA" }}
                                  </span>
                                </td>
                                <td style="min-width: 170px; white-space: normal;">
                                  <span style="font-size: 14px; font-weight: 700; line-height: 13px; color: #0BA042">
                                    {{ data.legs_data[1] && data.legs_data[1].remaining_target_in_perc
                                      ? data.legs_data[1].remaining_target_in_perc + "%"
                                      : "NA" }}
                                  </span>
                                  <br />
                                  <span style="font-size: 9px; font-weight: 500; color:#969696">
                                    As on
                                    {{
                                      data.legs_data[1].created_date_str
                                        ? moment(data.legs_data[1].created_date_str).format("MMM DD YYYY")
                                        : "NA"
                                    }}
                                  </span>
                                  <br />
                                  <span style="font-size: 9px; font-weight: 500; color:#969696">
                                    ({{ moment().diff(moment(data.legs_data[1].created_date_str), "days") }}
                                    Days from reco date)
                                  </span>
                                </td>

                                <td style="min-width: 120px; font-size: 12px; font-weight: 600; color:#000000;">
                                  ₹ {{ data.required_total_margin || "NA" }}
                                </td>

                                <td style="min-width: 100px; white-space: normal;">
                                  <span style="font-size: 12px; font-weight: 500; color:#000000">
                                    ₹ {{ data.legs_data[1].target_premium || "NA" }}
                                  </span>
                                  <br />
                                  <span style="font-size: 10px; font-weight: 600; line-height: 13px; color: #0BA042">
                                    {{
                                      data.legs_data[1].remaining_target_in_perc
                                        ? data.legs_data[1].remaining_target_in_perc + "%"
                                        : "NA"
                                    }}
                                  </span>
                                </td>

                                <td style="min-width: 80px; white-space: normal;">
                                  <span style="font-size: 12px; font-weight: 600; line-height:13px; color:#EA2526">
                                    ₹ {{ data.legs_data[1].stop_loss || "NA" }}
                                  </span>
                                  <br />
                                  <div v-if="data.legs_data[1].status === 'STOPLOSS_TRIGGERED'">
                                    <span style="font-size: 9px; font-weight: 500; line-height: 13px">
                                      {{
                                        data.legs_data[1].status_change_timestamp_str
                                          ? moment(data.legs_data[1].status_change_timestamp_str).format("MMM DD YYYY")
                                          : "NA"
                                      }}
                                    </span>
                                    <br />
                                    <span style="font-size: 9px; font-weight: 500; color: #000000; line-height: 13px">
                                      {{
                                        data.legs_data[1].status_change_timestamp_str
                                          ? moment(data.legs_data[1].status_change_timestamp_str).format("h:mm A")
                                          : ""
                                      }}
                                    </span>
                                  </div>
                                </td>

                                <td style="min-width: 40px; white-space: normal;"></td>
                                <td style="min-width: 60px; font-size: 12px; font-weight: 600;"></td>
                                <td style="min-width: 100px; white-space: normal; cursor: pointer;"></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>

            <!-- Context Menu for Options -->
            <div v-if="contextMenuOptions.visible && isStockAntsAdmin"
              :style="{ top: contextMenuOptions.y + 'px', left: contextMenuOptions.x + 'px' }" class="context-menu">
              <ul>
                <li @click="openEditPopupOptions">Edit Reco</li>
                <li @click="openRecoHistoryPopup">Reco Events History</li>
              </ul>
            </div>

            <!-- Edit Dialog for Options -->
            <el-dialog :visible.sync="editDialogOptions.visible" title="Edit FNO Recommendation" class="custom-dialog">
              <p class="reco-id">Reco ID: {{ editDialogOptions.reco_id }}</p>

              <!-- Status Selection -->
              <el-select v-model="editDialogOptions.status" placeholder="Select Status" class="status-select">
                <el-option v-for="status in recoStatusOptions" :key="status" :label="status"
                  :value="status"></el-option>
              </el-select>

              <div style="margin-top: 20px;">
                <h3 class="status-title">Status Details</h3>

                <div v-if="editDialogOptions.status === 'LIVE'" class="status-row">
                  <span class="status-label">Live Trigger Date & Time</span>
                  <el-date-picker v-model="editDialogOptions.liveTriggerDate" type="date" placeholder="Select Date" />
                  <el-time-picker v-model="editDialogOptions.liveTriggerTime" placeholder="Select Time" />
                  <el-input v-model.number="editDialogOptions.liveTriggerPrice" type="number"
                    placeholder="Enter Price" />
                </div>

                <div v-if="editDialogOptions.status === 'UPDATED'" class="status-row">
                  <span class="status-label">Updated Date & Time</span>
                  <el-date-picker v-model="editDialogOptions.updatedDate" type="date" placeholder="Select Date" />
                  <el-time-picker v-model="editDialogOptions.updatedTime" placeholder="Select Time" />
                  <el-input v-model.number="editDialogOptions.updatedPrice" type="number" placeholder="Enter Price" />
                </div>

                <div v-if="editDialogOptions.status === 'CLOSED'" class="status-row">
                  <span class="status-label">Closed Date & Time</span>
                  <el-date-picker v-model="editDialogOptions.closedDate" type="date" placeholder="Select Date" />
                  <el-time-picker v-model="editDialogOptions.closedTime" placeholder="Select Time" />
                  <el-input v-model.number="editDialogOptions.closedPrice" type="number" placeholder="Enter Price" />
                </div>

                <div v-if="editDialogOptions.status === 'TARGET ACHIEVED'" class="status-row">
                  <span class="status-label">Target Achieved Date & Time</span>
                  <el-date-picker v-model="editDialogOptions.targetAchievedDate" type="date"
                    placeholder="Select Date" />
                  <el-time-picker v-model="editDialogOptions.targetAchievedTime" placeholder="Select Time" />
                  <el-input v-model.number="editDialogOptions.targetAchievedPrice" type="number"
                    placeholder="Enter Price" />
                </div>

                <div v-if="editDialogOptions.status === 'TARGET NOT ACHIEVED'" class="status-row">
                  <span class="status-label">Target Not Achieved Date & Time</span>
                  <el-date-picker v-model="editDialogOptions.targetNotAchievedDate" type="date"
                    placeholder="Select Date" />
                  <el-time-picker v-model="editDialogOptions.targetNotAchievedTime" placeholder="Select Time" />
                  <el-input v-model.number="editDialogOptions.targetNotAchievedPrice" type="number"
                    placeholder="Enter Price" />
                </div>

                <div v-if="editDialogOptions.status === 'YET TO LIVE'" class="status-row">
                  <span class="status-label">Yet to Live Date & Time</span>
                  <el-date-picker v-model="editDialogOptions.yetToLiveDate" type="date" placeholder="Select Date" />
                  <el-time-picker v-model="editDialogOptions.yetToLiveTime" placeholder="Select Time" />
                </div>

                <div v-if="editDialogOptions.status === 'STOP LOSS TRIGGERED'" class="status-row">
                  <span class="status-label">Stop Loss Triggered Date & Time</span>
                  <el-date-picker v-model="editDialogOptions.stopLossTriggeredDate" type="date"
                    placeholder="Select Date" />
                  <el-time-picker v-model="editDialogOptions.stopLossTriggeredTime" placeholder="Select Time" />
                  <el-input v-model.number="editDialogOptions.stopLossTriggeredPrice" type="number"
                    placeholder="Enter Price" />
                </div>

                <div v-if="editDialogOptions.status === 'EXIT'" class="status-row">
                  <span class="status-label">Exit Date & Time</span>
                  <el-date-picker v-model="editDialogOptions.exitDate" type="date" placeholder="Select Date" />
                  <el-time-picker v-model="editDialogOptions.exitTime" placeholder="Select Time" />
                  <el-input v-model.number="editDialogOptions.exitPrice" type="number" placeholder="Enter Price" />
                </div>
              </div>

              <!-- Action Buttons -->
              <span slot="footer" class="dialog-footer">
                <el-button @click="editDialogOptions.visible = false" class="cancel-btn">Cancel</el-button>
                <el-button type="primary" @click="saveUpdatedStatusFNO" class="save-btn">Save</el-button>
              </span>
            </el-dialog>

            <el-dialog title="Reco Events History" :visible.sync="recoHistoryDialogVisible" width="600px"
              class="custom-dialog">
              <div v-if="recoEvents.length > 0">
                <el-timeline>
                  <el-timeline-item v-for="(event, index) in recoEvents" :key="index" :timestamp="event.timestamp"
                    placement="top">
                    <p><strong>Status:</strong> {{ event.status }}</p>
                    <p>{{ event.description }}</p>
                  </el-timeline-item>
                </el-timeline>
              </div>
              <div v-else>
                <p>No history available.</p>
              </div>

              <!-- Footer buttons (optional, match look) -->
              <span slot="footer" class="dialog-footer">
                <el-button @click="recoHistoryDialogVisible = false" class="cancel-btn">Close</el-button>
              </span>
            </el-dialog>

          </div>

          <div class="pagination" style="text-align:center">
            <el-pagination @current-change="handleBrokersPageChange" :current-page="paginationBrokers.current_page"
              :page-sizes="[5, 10, 20, 50]" :page-size="paginationBrokers.page_size"
              :total="paginationBrokers.total_entries" :pager-count="5"
              layout="total, prev, pager, next"></el-pagination>
          </div>
        </div>

        <div v-if="!is_broker_reco_list_loading && !brokersRecoList.length">
          <NoDataFound></NoDataFound>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var echarts = require("echarts");
import { serverAddr, serverHostName, serverAddrForCSV } from "../networkConfig";
import { filterCallBack } from "../mixins/filter";
import Hexagon from "@/components/Hexagon.vue";
import { screenSize } from "../mixins/ScreenSize.js";
import { required } from "vuelidate/lib/validators";
import CripNotice from "crip-vue-notice";
import { HelperNetworkCallBack } from "../mixins/Helper";
import moment from "moment";
import NoDataFound from "@/components/NoDataFound.vue";
import NavBar from "@/components/NavBar.vue";
import ExcelJS from "exceljs";
export default {
  name: "SADashboardAnalytics",

  mixins: [screenSize, HelperNetworkCallBack],

  components: {
    Hexagon,
    NavBar,
    NoDataFound,
  },

  data() {
    return {
      // FilterForDesktopView,
      nav_title: "Expert's Analytics",
      serverHostName: serverHostName,
      moment: moment,
      value1: "",
      value2: "",
      input2: "",
      selectedOption: "equity",
      // status: "",
      is_export_Loading: false,
      shareDialogVisible: false,
      currentPageSubscribedUsers: 1,
      paginationSubscribedUsers: {
        total_entries: 0,
        current_page: 1,
        page_size: 10,
      },
      subscribedUsersList: [],
      currentPageBrokers: 1,
      paginationBrokers: {
        total_entries: 0,
        current_page: 1,
        page_size: 10,
      },
      brokersRecoList: [],
      is_user_list_loading: false,
      is_broker_reco_list_loading: false,
      brokerCompanyName: localStorage.getItem("broker_company_name"),
      companyUrl: localStorage.getItem("company_url"),

      // Filters data return
      active_index_title: null,
      targetPeriodType: null,
      marketParticipants: [],
      marketExperts: [],
      recommendationType: [],
      strategyType: [],
      marketCap: [],
      recommendationStatus: [],
      strategyStatus: [],
      selectedExpert: null,
      expertOptions: [],
      isExpertLoading: false,
      selectedSector: "",
      sectors: [],
      selectedAdvisoryIndex: null,
      selectedExpert: null,
      expertOptions: [],
      isExpertLoading: false,
      targetPeriodType: null,
      selectedTargetPeriod: "",
      contextMenu: { visible: false, x: 0, y: 0, selectedRow: null },  //  for equity
      editDialog: { visible: false, reco_id: null },

      exportEquityList: [],
      is_options_export_loading: false,
      exportOptionsList: [],
      recoStatusOptions: [
        'LIVE',
        'UPDATED',
        'CLOSED',
        'TARGET ACHIEVED',
        'TARGET NOT ACHIEVED',
        'YET TO LIVE',
        'STOP LOSS TRIGGERED',
        'EXIT'
      ],
      editDialog: {
        visible: false,
        reco_id: null,
        status: "",
        liveTriggerDate: null,
        liveTriggerTime: null,
        liveTriggerPrice: null,
        updatedDate: null,
        updatedTime: null,
        updatedPrice: null,
        closedDate: null,
        closedTime: null,
        closedPrice: null,
        targetAchievedDate: null,
        targetAchievedTime: null,
        targetAchievedPrice: null,
        targetNotAchievedDate: null,
        targetNotAchievedTime: null,
        targetNotAchievedPrice: null,
        yetToLiveDate: null,
        yetToLiveTime: null,
        stopLossTriggeredDate: null,
        stopLossTriggeredTime: null,
        stopLossTriggeredPrice: null,
        exitDate: null,
        exitTime: null,
        exitPrice: null,
        selectedOption: "equity",
        brokerCompanyName: localStorage.getItem("broker_company_name"),
        companyUrl: localStorage.getItem("company_url"),
      },

      // Telegram / broker list dialog state
      telegramDialogVisible: false,
      brokerSearch: '',
      brokerList: [],
      selectedBrokers: [],
      selectedRecoId: null,
      loadingBrokers: false,

      // for options reco update
      // Context menu for Options (FNO)
      contextMenuOptions: { visible: false, x: 0, y: 0, selectedRow: null },

      // Edit dialog for Options (FNO)
      editDialogOptions: {
        visible: false,
        reco_id: null,
        status: "",
      },
      recoEvents: [],
      recoHistoryDialogVisible: false,
      from: "",
      to: "",
      defaultStartDate: new Date(new Date().setMonth(new Date().getMonth() - 1)),
      defaultEndDate: new Date(),

      // Options date range
      start_date: "",
      end_date: "",
      defaultOptionsStartDate: new Date(new Date().setMonth(new Date().getMonth() - 1)),
      defaultOptionsEndDate: new Date(),

      optionsStartDatePickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      optionsEndDatePickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },

  validations: {
    review: {
      required,
    },
  },

  mounted() {
    // Automatically call the API for the default selection (Equity)
    this.handleSelectionChange(this.selectedOption);
    this.getSectors();
  },
  watch: {
    //FOR EQUITY
    from(newVal) {
      this.from = newVal ? this.formatDate(newVal) : "";
      if (this.from && this.to) {
        this.resetEquityPagination();
        this.filterUserData(); // or this.getEquityRecolist()
      }
    },
    to(newVal) {
      this.to = newVal ? this.formatDate(newVal) : "";
      if (this.from && this.to) {
        this.resetEquityPagination();
        this.filterUserData(); // or this.getEquityRecolist()
      }
    },

    // FOR OPTIONS
    start_date(newVal) {
      this.start_date = newVal ? this.formatDate(newVal) : "";
      if (this.start_date && this.end_date) {
        this.resetOptionsPagination()
        this.getOptionsRecoList();
      }
    },
    end_date(newVal) {
      this.end_date = newVal ? this.formatDate(newVal) : "";
      if (this.start_date && this.end_date) {
        this.resetOptionsPagination()
        this.getOptionsRecoList();
      }
    },
    "editDialog.status"(newVal) {
      // console.log("Status changed to:", newVal);
    },

    recommendationType() {
      this.resetEquityPagination();
      this.getEquityRecolist();
    },

    marketCap() {
      this.resetEquityPagination();
      this.getEquityRecolist();
    },
    marketParticipants() {
      this.resetEquityPagination();
      this.getEquityRecolist();
    },
    recommendationStatus() {
      this.resetEquityPagination();
      this.getEquityRecolist();
    },
    targetPeriodType(newVal) {
      this.resetEquityPagination();
      this.getEquityRecolist();
    },
    selectedTargetPeriod(newVal) {
      this.resetEquityPagination();
      this.getEquityRecolist();
    },
    // Filters for options
    strategyType() {
     this.resetOptionsPagination()
      this.getOptionsRecoList();
    },
    marketExperts() {
      this.resetOptionsPagination()
      this.getOptionsRecoList();
    },
    strategyStatus() {
      this.resetOptionsPagination()
      this.getOptionsRecoList();
    },
  },

  methods: {
    openTelegramDialog(row) {
      this.telegramDialogVisible = true
      this.selectedRecoId = row.reco_id || row.id
      this.selectedBrokers = []
      this.getTelegramBrokerList()
    },

    getTelegramBrokerList() {
      this.loadingBrokers = true

      const payload = {
        reco_id: this.selectedRecoId,
        client_ids: []
      }

      serverAddr
        .get("/tpd/biz/v1/teligram/group/list", { params: payload })
        .then(res => {
          const list = (res && res.data && res.data.data) ? res.data.data : (res && res.data) || []
          this.brokerList = Array.isArray(list) ? list : []
        })
        .finally(() => {
          this.loadingBrokers = false
        })
    },

    sendTelegramMessage() {
      const clientIds = (this.selectedBrokers || []).map(id => Number(id)).filter(n => !isNaN(n))

      const payload = {
        reco_id: this.selectedRecoId,
        client_ids: clientIds
      }

      serverAddr
        .post("/eqity/biz/v1/teligram/group/send_message", payload)
        .then(() => {
          this.$message.success("Message sent to Telegram successfully!")
          this.telegramDialogVisible = false
        })
        .catch(err => {
          // show error message if available
          const msg = err && err.response && err.response.data && err.response.data.message ? err.response.data.message : 'Failed to send message'
          this.$message.error(msg)
        })
    },

    // Reset date filter for equity
    clearEquityFilters() {
      this.from = "";
      this.to = "";
      this.getEquityRecolist(); // re-fetch without date filters
    },
    isEquityFilterActive() {
      return this.from !== "" || this.to !== "";
    },
    // Reset date filter for options
    clearOptionsFilters() {
      this.start_date = "";
      this.end_date = "";
      this.currentPageBrokers = 1; // Reset to page 1 when filter is cleared
      this.paginationBrokers.current_page = 1;
      this.getOptionsRecoList(); // Call API again without date filter
    },
    isOptionsFilterActive() {
      return this.start_date !== "" || this.end_date !== "";
    },
    handleSelectionChange(value) {
      if (value === "equity") {
        this.getEquityRecolist();
      } else if (value === "options") {
        this.getOptionsRecoList();
      }
    },
    //Below Method code for Right click menu functionality equity
    openContextMenu(event, row) {
      event.preventDefault();
      this.contextMenu = {
        visible: true,
        x: event.clientX,
        y: event.clientY,
        selectedRow: row,
      };
      document.addEventListener("click", this.closeContextMenu);
    },
    closeContextMenu() {
      this.contextMenu.visible = false;
      document.removeEventListener("click", this.closeContextMenu);
    },
    openEditPopup() {
      if (this.contextMenu.selectedRow) {
        this.editDialog.reco_id = this.contextMenu.selectedRow.id;
        this.editDialog.status = this.contextMenu.selectedRow.reco_status;
        this.editDialog.visible = true;
      }
      this.closeContextMenu();
    },

    //Below Method code for Right click menu functionality options
    openEditPopupOptions() {
      const selectedReco = this.contextMenuOptions.selectedRow;

      if (selectedReco && selectedReco.id) {
        // console.log("Selected Reco:", selectedReco); // Debug log

        this.editDialogOptions.reco_id = selectedReco.id || "N/A";
        this.editDialogOptions.status = selectedReco.status || "";

        this.editDialogOptions.visible = true;
      } else {
        console.error("No selected reco or invalid data structure!");
      }

      this.closeContextMenuOptions();
    },

    // Popup open code for options reco history
    openRecoHistoryPopup() {
      const selectedReco = this.contextMenuOptions.selectedRow;
      // console.log("Full selectedReco object:", selectedReco);

      if (selectedReco && Array.isArray(selectedReco.events)) {
        if (selectedReco.events.length > 0) {
          this.recoEvents = selectedReco.events;
        } else {
          console.warn("No events found in selectedReco.events");
          this.recoEvents = [];
        }
        this.recoHistoryDialogVisible = true;
      } else {
        console.error("Invalid reco structure or no events!");
        this.recoEvents = [];
      }
      this.contextMenuOptions.visible = false;
    },

    closeRecoHistoryPopup() {
      this.recoHistoryDialogVisible = false;
      this.recoEvents = [];
    },

    closeContextMenuOptions() {
      this.contextMenuOptions.visible = false;
      document.removeEventListener("click", this.closeContextMenuOptions);
    },

    openContextMenuOptions(event, row, index) {
      this.contextMenuOptions.visible = true;
      this.contextMenuOptions.x = event.clientX;
      this.contextMenuOptions.y = event.clientY;
      this.contextMenuOptions.selectedRow = row;    // This should now be either data.data[0] or data.data[1]
      this.contextMenuOptions.selectedIndex = index;

      document.addEventListener("click", this.closeContextMenuOptions);
    },

    // Method for save updated value and send to options reco api payload 
    saveUpdatedStatusFNO() {
      const selectedStatus = this.editDialogOptions.status;

      const statusMapping = {
        "YET TO LIVE": "YET_TO_LIVE",
        "LIVE": "LIVE",
        "UPDATED": "UPDATED",
        "EXIT": "EXIT",
        "EXIT AND REENTRY": "EXIT_AND_REENTRY",
        "TARGET ACHIEVED": "TARGET_ACHIEVED",
        "TARGET NOT ACHIEVED": "TARGET_NOT_ACHIEVED",
        "CLOSED": "CLOSED",
        "STOP LOSS TRIGGERED": "STOPLOSS_TRIGGERED",
        "STOPPED": "STOPPED",
      };

      if (!selectedStatus || selectedStatus.trim() === "") {
        this.$message.error("Please select a status.");
        return;
      }

      const formatDateTime = (date, time) => {
        if (!date || !time) return null;
        return moment(`${moment(date).format("YYYY-MM-DD")}T${moment(time).format("HH:mm:ss")}`).format("YYYY-MM-DDTHH:mm:ss");
      };

      let requestPayload = {
        id: this.editDialogOptions.reco_id,
        status: statusMapping[selectedStatus] || "YET_TO_LIVE",
      };

      switch (selectedStatus) {
        case "LIVE":
          requestPayload.live_trigger_timestamp = formatDateTime(this.editDialogOptions.liveTriggerDate, this.editDialogOptions.liveTriggerTime);
          // requestPayload.status_action_price = this.editDialogOptions.liveTriggerPrice || null;
          break;
        case "UPDATED":
          requestPayload.updated_timestamp = formatDateTime(this.editDialogOptions.updatedDate, this.editDialogOptions.updatedTime);
          requestPayload.status_action_price = this.editDialogOptions.updatedPrice || null;
          break;
        case "CLOSED":
          requestPayload.closed_timestamp = formatDateTime(this.editDialogOptions.closedDate, this.editDialogOptions.closedTime);
          requestPayload.status_action_price = this.editDialogOptions.closedPrice || null;
          break;
        case "TARGET ACHIEVED":
          requestPayload.target_hit_timestamp = formatDateTime(this.editDialogOptions.targetAchievedDate, this.editDialogOptions.targetAchievedTime);
          requestPayload.status_action_price = this.editDialogOptions.targetAchievedPrice || null;
          break;
        case "TARGET NOT ACHIEVED":
          requestPayload.target_miss_timestamp = formatDateTime(this.editDialogOptions.targetNotAchievedDate, this.editDialogOptions.targetNotAchievedTime);
          requestPayload.status_action_price = this.editDialogOptions.targetNotAchievedPrice || null;
          break;
        case "YET TO LIVE":
          requestPayload.yet_to_live_timestamp = formatDateTime(this.editDialogOptions.yetToLiveDate, this.editDialogOptions.yetToLiveTime);
          break;
        case "STOP LOSS TRIGGERED":
          requestPayload.stop_loss_timestamp = formatDateTime(this.editDialogOptions.stopLossTriggeredDate, this.editDialogOptions.stopLossTriggeredTime);
          requestPayload.status_action_price = this.editDialogOptions.stopLossTriggeredPrice || null;
          break;
        case "EXIT":
          requestPayload.exit_timestamp = formatDateTime(this.editDialogOptions.exitDate, this.editDialogOptions.exitTime);
          requestPayload.status_action_price = this.editDialogOptions.exitPrice || null;
          break;
      }

      serverAddr.post("/options/admin/v1/update_fno_recommendation", requestPayload)
        .then(() => {
          this.$message.success("FNO recommendation updated successfully!");
          this.editDialogOptions.visible = false;
          this.getOptionsRecoList();
        })
        .catch(error => {
          console.error("Error updating FNO recommendation:", error);
          this.$message.error("Something went wrong!");
        });
    },

    // Method for save updated value and send to payload
    saveUpdatedStatus() {
      const statusMapping = {
        "LIVE": "0",
        "CLOSED": "1",
        "UPDATED": "2",
        "TARGET ACHIEVED": "3",
        "TARGET NOT ACHIEVED": "4",
        "YET TO LIVE": "5",
        "STOP LOSS TRIGGERED": "6",
        "EXIT": "7",
      };

      const selectedStatus = this.editDialog.status;
      if (!selectedStatus) {
        this.$message.error("Please select a status.");
        return;
      }

      let requestPayload = {
        id: this.editDialog.reco_id,
        reco_status: statusMapping[selectedStatus] || "0",
      };

      const formatDateTime = (date, time) => {
        if (!date || !time) return null;
        return moment.utc(`${moment(date).format("YYYY-MM-DD")}T${moment(time).format("HH:mm:ss.SSS")}`).format("YYYY-MM-DDTHH:mm:ss.SSS");
      };

      switch (selectedStatus) {
        case "LIVE":
          requestPayload.live_trigger_date_time = formatDateTime(this.editDialog.liveTriggerDate, this.editDialog.liveTriggerTime);
          requestPayload.live_trigger_price = this.editDialog.liveTriggerPrice || null;
          break;
        case "UPDATED":
          requestPayload.updated_time = formatDateTime(this.editDialog.updatedDate, this.editDialog.updatedTime);
          requestPayload.updated_price = this.editDialog.updatedPrice || null;
          break;
        case "CLOSED":
          requestPayload.closed_time = formatDateTime(this.editDialog.closedDate, this.editDialog.closedTime);
          requestPayload.closed_price = this.editDialog.closedPrice || null;
          break;
        case "TARGET ACHIEVED":
          requestPayload.target_achieved_date_time = formatDateTime(this.editDialog.targetAchievedDate, this.editDialog.targetAchievedTime);
          requestPayload.target_achieved_price = this.editDialog.targetAchievedPrice || null;
          break;
        case "TARGET NOT ACHIEVED":
          requestPayload.target_not_achieved_date_time = formatDateTime(this.editDialog.targetNotAchievedDate, this.editDialog.targetNotAchievedTime);
          requestPayload.target_not_achieved_price = this.editDialog.targetNotAchievedPrice || null;
          break;
        case "YET TO LIVE":
          requestPayload.yet_to_live_time = formatDateTime(this.editDialog.yetToLiveDate, this.editDialog.yetToLiveTime);
          break;
        case "STOP LOSS TRIGGERED":
          requestPayload.stop_loss_triggered_date_time = formatDateTime(this.editDialog.stopLossTriggeredDate, this.editDialog.stopLossTriggeredTime);
          requestPayload.stop_loss_triggered_price = this.editDialog.stopLossTriggeredPrice || null;
          break;
        case "EXIT":
          requestPayload.exit_time = formatDateTime(this.editDialog.exitDate, this.editDialog.exitTime);
          requestPayload.exit_price = this.editDialog.exitPrice || null;
          break;
      }

      console.log("Final Payload:", requestPayload);

      serverAddr.post("/recommendation/admin/v1/equity_update_reco", requestPayload)
        .then(response => {
          this.$message.success("Recommendation updated successfully!");
          this.editDialog.visible = false;
          this.getEquityRecolist(); // Call getEquityRecolist() after successful update
        })
        .catch(error => {
          console.error("Error updating recommendation:", error);
          this.$message.error("Something went wrong!");
        });
    },

    toggleAdvisory(index) {
      this.selectedAdvisoryIndex =
        this.selectedAdvisoryIndex === index ? null : index;
    },
    openSharePopup() {
      this.shareDialogVisible = true;
    },

    // Below code for equity share feature for whatsapp & telegram
    copyForWhatsApp(data) {
      const publishedBy = data.user.full_name ? data.user.full_name : "--";
      const sebiNumber = data.user.sebi_regi_number
        ? data.user.sebi_regi_number
        : "--";
      const stockName = data.stock && data.stock.name ? data.stock.name : "--";
      const recoType = data.reco || "--";
      const targetPeriod = data.target_period || "--";
      const entryPrice = data.reco_open_price ? `Rs. ${data.reco_open_price}` : "--";
      const recoTimestamp = data.created_at
        ? moment(data.created_at).format("h:mma, Do MMM YYYY")
        : "--";
      const targetPrice = data.target_price
        ? `Rs. ${data.target_price} (${data.target_potential}%)`
        : "--";
      const stopLoss = data.stop_loss ? `Rs. ${data.stop_loss}` : "--";
      const recoStatus = data.reco_status || "--";

      // Use potential_as_of_current_date for remaining profit percentage
      const remainingProfitPercentage = data.potential_as_of_current_date
        ? `${data.potential_as_of_current_date.toFixed(2)}%`
        : "NA";

      // Only show remaining profit percentage
      const remainingProfit = remainingProfitPercentage;

      // Risk level processing
      const risk = data.risk_tag
        ? data.risk_tag
          .replace("_risk", "")
          .replace(/_/g, " ")
          .toUpperCase()
        : "NA";

      // Use the brokerCompanyName already set in mounted
      const brokerCompanyName = this.brokerCompanyName;

      // Create a message to copy with bold titles
      const message = `*Published by*: ${publishedBy} (SEBI NO: ${sebiNumber})
*Stock Name*: ${stockName}
*Recommendation Type*: ${recoType}
*Target Period*: ${targetPeriod}
*Entry Price*: ${entryPrice}
*Recommendation Time Stamp*: ${recoTimestamp}
*Target Price*: ${targetPrice}
*Stop Loss*: ${stopLoss}
*Recommendation Status*: ${recoStatus}
*Remaining Target*: ${remainingProfit}

*${brokerCompanyName}*

*Powered By StockAnts*

${this.companyUrl.length
          ? `Checkout ${this.companyUrl
          } for single access to multi–SEBI Experts’ Recommendations with Price estimate tracking.`
          : ""
        }`;

      // Use the Clipboard API to copy the message
      navigator.clipboard.writeText(message).then(
        () => {
          // Display success message
          this.$message({
            message: "Copied to clipboard for WhatsApp!",
            type: "success",
            duration: 3000,
          });
        },
        (err) => {
          console.error("Failed to copy text: ", err);
          // Display error message
          this.$message({
            message: "Failed to copy text.",
            type: "error",
            duration: 3000, // Customize the duration
          });
        }
      );
    },

    copyForTelegram(data) {
      const publishedBy = data.user.full_name ? data.user.full_name : "--";
      const sebiNumber = data.user.sebi_regi_number
        ? data.user.sebi_regi_number
        : "--";
      const stockName = data.stock && data.stock.name ? data.stock.name : "--";
      const recoType = data.reco || "--";
      const targetPeriod = data.target_period || "--";
      const entryPrice = data.reco_open_price ? `Rs. ${data.reco_open_price}` : "--";
      const recoTimestamp = data.created_at
        ? moment(data.created_at).format("h:mma, Do MMM YYYY")
        : "--";
      const targetPrice = data.target_price
        ? `Rs. ${data.target_price} (${data.target_potential}%)`
        : "--"; // Use target_potential
      const stopLoss = data.stop_loss ? `Rs. ${data.stop_loss}` : "--";
      const recoStatus = data.reco_status || "--";

      // Use potential_as_of_current_date for remaining profit percentage
      const remainingProfitPercentage = data.potential_as_of_current_date
        ? `${data.potential_as_of_current_date.toFixed(2)}%`
        : "NA";
      const remainingProfit = remainingProfitPercentage;

      // Risk level processing
      const risk = data.risk_tag
        ? data.risk_tag
          .replace("_risk", "")
          .replace(/_/g, " ")
          .toUpperCase()
        : "NA";

      // Use the brokerCompanyName already set in mounted
      const brokerCompanyName = this.brokerCompanyName;

      // Create a message to copy with bold titles for Telegram
      const message = `**Published by**: ${publishedBy} (SEBI NO: ${sebiNumber})
**Stock Name**: ${stockName}
**Recommendation Type**: ${recoType}
**Target Period**: ${targetPeriod}
**Entry Price**: ${entryPrice}
**Recommendation Time Stamp**: ${recoTimestamp}
**Target Price**: ${targetPrice}
**Stop Loss**: ${stopLoss}
**Recommendation Status**: ${recoStatus}
**Remaining Target**: ${remainingProfit}

**${brokerCompanyName}**

**Powered By StockAnts**

${this.companyUrl.length
          ? `Checkout ${this.companyUrl
          } for single access to multi–SEBI Experts’ Recommendations with Price estimate tracking.`
          : ""
        }`;

      // Use the Clipboard API to copy the message
      navigator.clipboard.writeText(message).then(
        () => {
          // Display success message
          this.$message({
            message: "Copied to clipboard for Telegram!",
            type: "success",
            duration: 3000,
          });
        },
        (err) => {
          console.error("Failed to copy text: ", err);
          // Display error message
          this.$message({
            message: "Failed to copy text.",
            type: "error",
            duration: 3000,
          });
        }
      );
    },

    // Below code for options share feature for whatsapp & telegram
    copyForWhatsAppOptions(reco_details) {
      const publishedBy =
        reco_details.expert_detail && reco_details.expert_detail.full_name
          ? reco_details.expert_detail.full_name
          : "--";

      const sebiNumber =
        reco_details.expert_detail && reco_details.expert_detail.sebi_regi_number
          ? reco_details.expert_detail.sebi_regi_number
          : "--";

      const indiceName = reco_details.title ? reco_details.title : "--";

      const strategyTimestamp =
        reco_details.created_date_str
          ? moment(reco_details.created_date_str).format("h:mma, Do MMM YYYY")
          : "--";

      const strategyType = reco_details.tags ? reco_details.tags : "--";

      const approxCapital =
        reco_details.required_total_margin
          ? "Rs. " + reco_details.required_total_margin
          : "--";

      const status = reco_details.status ? reco_details.status : "--";

      const remainingProfitSentence =
        reco_details.avg_remaining_potential_perc !== null &&
          reco_details.avg_remaining_potential_perc !== undefined
          ? reco_details.avg_remaining_potential_perc + "%"
          : "--";

      const risk =
        reco_details.expert_detail && reco_details.expert_detail.risk_category
          ? reco_details.expert_detail.risk_category
          : "NA";

      // Leg 1
      let leg1Details = "";
      if (reco_details.legs_data && reco_details.legs_data[0]) {
        const leg1 = reco_details.legs_data[0];
        leg1Details = `
Leg 1:
Leg Type: ${leg1.direction || "--"}
Strike Price: ${leg1.stock_data && leg1.stock_data.strike
            ? leg1.stock_data.strike + leg1.stock_data.instrument_type
            : "--"
          }
Entry price: Rs. ${leg1.entry_premium || "--"}
Target Price: Rs. ${leg1.target_premium || "--"}
Stop Loss: Rs. ${leg1.stop_loss || "--"}
`;
      }

      // Leg 2
      let leg2Details = "";
      if (reco_details.legs_data && reco_details.legs_data[1]) {
        const leg2 = reco_details.legs_data[1];
        leg2Details = `
Leg 2:
Leg Type: ${leg2.direction || "--"}
Strike Price: ${leg2.stock_data && leg2.stock_data.strike
            ? leg2.stock_data.strike + leg2.stock_data.instrument_type
            : "--"
          }
Entry price: Rs. ${leg2.entry_premium || "--"}
Target Price: Rs. ${leg2.target_premium || "--"}
Stop Loss: Rs. ${leg2.stop_loss || "--"}
`;
      }

      const brokerCompanyName = this.brokerCompanyName;

      const message = `*Published by*: ${publishedBy} (SEBI NO: ${sebiNumber})
*Indice Name*: ${indiceName}
*Strategy Timestamp*: ${strategyTimestamp}
*Strategy Type*: ${strategyType}
*Approx Capital Required*: ${approxCapital}
*Status*: ${status}
*Risk*: ${risk}
*Remaining Target*: ${remainingProfitSentence}

${leg1Details}${leg2Details}

**${brokerCompanyName}**

*Powered By StockAnts*

Checkout ${this.companyUrl
        } for single access to multi–SEBI Experts’ Recommendations with Price estimate tracking.`;

      navigator.clipboard.writeText(message).then(
        () => {
          this.$message({
            message: "Copied to clipboard for WhatsApp!",
            type: "success",
            duration: 3000,
          });
        },
        (err) => {
          console.error("Failed to copy text: ", err);
          this.$message({
            message: "Failed to copy text.",
            type: "error",
            duration: 3000,
          });
        }
      );
    },

    copyForTelegramOptions(reco_details) {
      const publishedBy =
        reco_details.expert_detail && reco_details.expert_detail.full_name
          ? reco_details.expert_detail.full_name
          : "--";

      const sebiNumber =
        reco_details.expert_detail && reco_details.expert_detail.sebi_regi_number
          ? reco_details.expert_detail.sebi_regi_number
          : "--";

      const indiceName = reco_details.title ? reco_details.title : "--";

      const strategyTimestamp =
        reco_details.created_date_str
          ? moment(reco_details.created_date_str).format("h:mma, Do MMM YYYY")
          : "--";

      const strategyType = reco_details.tags ? reco_details.tags : "--";

      const approxCapital =
        reco_details.required_total_margin
          ? "Rs. " + reco_details.required_total_margin
          : "--";

      const status = reco_details.status ? reco_details.status : "--";

      const remainingProfitSentence =
        reco_details.avg_remaining_potential_perc !== null &&
          reco_details.avg_remaining_potential_perc !== undefined
          ? reco_details.avg_remaining_potential_perc + "%"
          : "--";

      const risk =
        reco_details.expert_detail && reco_details.expert_detail.risk_category
          ? reco_details.expert_detail.risk_category
          : "NA";

      // Leg 1
      let leg1Details = "";
      if (reco_details.legs_data && reco_details.legs_data[0]) {
        const leg1 = reco_details.legs_data[0];
        leg1Details = `
**Leg 1**:
Leg Type: ${leg1.direction || "--"}
Strike Price: ${leg1.stock_data && leg1.stock_data.strike
            ? leg1.stock_data.strike + leg1.stock_data.instrument_type
            : "--"
          }
Entry price: Rs. ${leg1.entry_premium || "--"}
Target Price: Rs. ${leg1.target_premium || "--"}
Stop Loss: Rs. ${leg1.stop_loss || "--"}`;
      }

      // Leg 2
      let leg2Details = "";
      if (reco_details.legs_data && reco_details.legs_data[1]) {
        const leg2 = reco_details.legs_data[1];
        leg2Details = `

**Leg 2**:
Leg Type: ${leg2.direction || "--"}
Strike Price: ${leg2.stock_data && leg2.stock_data.strike
            ? leg2.stock_data.strike + leg2.stock_data.instrument_type
            : "--"
          }
Entry price: Rs. ${leg2.entry_premium || "--"}
Target Price: Rs. ${leg2.target_premium || "--"}
Stop Loss: Rs. ${leg2.stop_loss || "--"}`;
      }

      const brokerCompanyName = this.brokerCompanyName;

      const message = `**Published by**: ${publishedBy} (SEBI NO: ${sebiNumber})
**Indice Name**: ${indiceName}
**Strategy Timestamp**: ${strategyTimestamp}
**Strategy Type**: ${strategyType}
**Approx Capital Required**: ${approxCapital}
**Status**: ${status}
**Risk**: ${risk}
**Remaining Target**: ${remainingProfitSentence}
${leg1Details}${leg2Details}

**${brokerCompanyName}**

**Powered By StockAnts**

${this.companyUrl.length
          ? `Checkout ${this.companyUrl} for single access to multi–SEBI Experts’ Recommendations with Price estimate tracking.`
          : ""
        }`;

      navigator.clipboard.writeText(message).then(
        () => {
          this.$message({
            message: "Copied to clipboard for Telegram!",
            type: "success",
            duration: 3000,
          });
        },
        (err) => {
          console.error("Failed to copy text: ", err);
          this.$message({
            message: "Failed to copy text.",
            type: "error",
            duration: 3000,
          });
        }
      );
    },

    copyToClipboard(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
    },
    formatDate(date) {
      return date ? moment(date).format("YYYY-MM-DD") : "";
    },

    filterUserData() {
      this.currentPage = 1;
      this.getEquityRecolist();
    },

    // For subscribed users pagination
    handleSubscribedUsersPageChange(val) {
      this.currentPageSubscribedUsers = val;
      this.getEquityRecolist();
    },

    toggleFilterSection(title) {
      this.active_index_title = this.active_index_title === title ? "" : title;
    },
    // Search experts by name for equity
    searchExperts(query) {
      if (query) {
        this.isExpertLoading = true;
        serverAddr
          .post("/recommendation/v1/search-expert", { query }) // Send search query for expert
          .then((response) => {
            // Map expert data to dropdown options
            this.expertOptions = response.data.data.map((expert) => ({
              id: expert.id,
              full_name: expert.full_name,
              profession: expert.profession,
            }));
            this.isExpertLoading = false;
          })
          .catch((error) => {
            console.error("Error fetching experts:", error);
            this.isExpertLoading = false;
          });
      }
    },

    // Handle expert selection and pass the id to the API
    handleExpertSelection(expertFullName) {
      console.log("Selected Expert Full Name:", expertFullName);
      this.currentPageSubscribedUsers = 1;
      this.paginationSubscribedUsers.current_page = 1;
      this.getEquityRecolist(); // Fetch data based on the selected expert
    },

    // Search experts by name for options
    searchExperts(query) {
      if (query) {
        this.isExpertLoading = true; // Show loading state
        serverAddr
          .post("/recommendation/v1/search-expert", { query }) // Send search query for expert
          .then((response) => {
            // Map expert data to dropdown options
            this.expertOptions = response.data.data.map((expert) => ({
              id: expert.id,
              full_name: expert.full_name,
              profession: expert.profession,
            }));
            this.isExpertLoading = false; // Hide loading state
          })
          .catch((error) => {
            console.error("Error fetching experts:", error);
            this.isExpertLoading = false; // Hide loading state on error
          });
      } else {
        this.expertOptions = []; // Clear options if query is empty
      }
    },

    handleExpertSelection(value) {
      this.resetOptionsPagination()
      this.getOptionsRecoList();
    },

    // Method to fetch sectors from API
    getSectors() {
      serverAddr
        .post("/recommendation/v1/sector", {})
        .then((response) => {
          if (response.data.status) {
            // Assuming the response structure has data with "number" and "sector" fields
            this.sectors = response.data.data || [];
          } else {
            console.error("Error fetching sectors:", response.data.validation);
          }
        })
        .catch((error) => {
          console.error("Error fetching sectors:", error);
        });
    },

    // Method to fetch recommendations after selecting a sector
    getSectorAndRecommendations() {
      // console.log("Selected Sector:", this.selectedSector);
      if (this.selectedSector) {
        this.currentPageSubscribedUsers = 1;
        this.paginationSubscribedUsers.current_page = 1;
        this.getEquityRecolist();
      }
    },

    // Method to fetch recommendations with filters applied
    onTargetPeriodChange() {
      // Trigger API call only once when target period is selected
      this.currentPageSubscribedUsers = 1;
      this.paginationSubscribedUsers.current_page = 1;
      this.getEquityRecolist();
    },
    getEquityRecolist() {
      this.is_user_list_loading = true;

      // Combine selected filters from all checkbox groups into a single array
      const filters = [
        ...this.recommendationType,
        ...this.marketCap,
        ...this.marketParticipants,
        ...this.recommendationStatus,
      ];

      // Prepare the target period payload based on the selected option
      const targetPeriodPayload = this.targetPeriodType
        ? { key: this.targetPeriodType }
        : {};

      const requestPayload = {
        page_no: this.currentPageSubscribedUsers,
        page_per_entries: this.paginationSubscribedUsers.page_size,
        company_id_list: [],
        filters: filters, // Send the combined filters array
        target_period: targetPeriodPayload, // Send the selected target period
        stock_id: this.stockId,
        expert_name: this.selectedExpert || "", // Use selected expert's full name
        sector: this.selectedSector || "",
        from: this.from,
        to: this.to,
      };

      // API call to fetch filtered equity recommendations list
      serverAddr
        .post("/recommendation/admin/v1/equity_dashboard", requestPayload)
        .then((response) => {
          if (response.data.status) {
            this.subscribedUsersList = response.data.data || [];
            this.paginationSubscribedUsers = {
              total_entries: response.data.pagination.total_entries || 0,
              current_page: response.data.pagination.current_page || 1,
              page_size: response.data.pagination.page_size || 10,
            };
          } else {
            this.subscribedUsersList = [];
            this.resetPaginationS();
          }
          this.is_user_list_loading = false;
        })
        .catch((error) => {
          console.error("Error fetching Equity Reco list:", error);
          this.subscribedUsersList = [];
          this.resetPaginationS();
          this.is_user_list_loading = false;
        });
    },

    resetPaginationS() {
      this.paginationSubscribedUsers = {
        total_entries: 0,
        current_page: 1,
        page_size: 10,
      };
    },

    // Helper method to reset equity pagination
    resetEquityPagination() {
      this.currentPageSubscribedUsers = 1;
      this.paginationSubscribedUsers.current_page = 1;
    },

    // Helper method to reset options pagination
    resetOptionsPagination() {
      this.currentPageBrokers = 1;
      this.paginationBrokers.current_page = 1;
    },

    // Below code for expoert equity recommendations
    getEquityRecommendationsForExport() {
      this.is_export_Loading = true;

      const exportPayload = {
        page_no: 1,
        page_per_entries: 10000,
        from: this.from,
        to: this.to,
        segments: this.filterSegment ? [this.filterSegment] : [],
        is_export: true,
      };

      serverAddr
        .post('/recommendation/admin/v1/equity_dashboard', exportPayload)
        .then((response) => {
          if (response.data.status) {
            this.exportEquityList = response.data.data;
            this.downloadEquityExcel();
          } else {
            this.is_export_Loading = false;
          }
        })
        .catch((error) => {
          console.error("Export error:", error);
          this.is_export_Loading = false;
        });
    },

    async downloadEquityExcel() {
      this.is_export_Loading = true;

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("EquityReco");

      // Define header row
      const headers = [
        "S.No",
        "Reco Date",
        "Stock Name",
        "Reco",
        "Reco Status",
        "Reco Price",
        "Performance",
        "CMP",
        "Remaining Target",
        "Target",
        "SL",
        "Risk",
        "Expert Name",
        "SEBI No."
      ];

      worksheet.addRow(headers);

      // Add data rows
      this.exportEquityList.forEach((item, index) => {
        worksheet.addRow([
          index + 1,
          item.created_at ? moment(item.created_at).format("MMM DD YYYY, h:mm A") : "NA",
          item.stock && item.stock.name ? item.stock.name : "NA",
          item.reco ? item.reco : "NA",
          item.reco_status ? item.reco_status : "NA",
          item.reco_open_price != null ? item.reco_open_price : "NA",
          item.performance != null ? item.performance + "%" : "NA",
          item.stock && item.stock.current_price != null ? item.stock.current_price : "NA",
          item.potential_as_of_current_date != null ? item.potential_as_of_current_date + "%" : "NA",
          item.target_price != null ? item.target_price : "NA",
          item.stop_loss != null ? item.stop_loss : "NA",
          item.risk_tag ? item.risk_tag : "NA",
          item.user && item.user.full_name ? item.user.full_name : "NA",
          item.user && item.user.sebi_regi_number ? item.user.sebi_regi_number : "NA"
        ]);
      });

      // Optional: set column widths (improves readability)
      worksheet.columns.forEach((column) => {
        column.width = 18;
      });

      // Generate Excel file and trigger download
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Equity_Recommendation_${moment().format("YYYYMMDD_HHmmss")}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      this.is_export_Loading = false;
    },

    // Method for Delete Reco
    deleteReco(data) {
      const stockName = data.stock.name || 'this recommendation';

      this.$confirm(
        `Are you sure you want to delete the reco for "${stockName}"?`,
        'Confirm Delete',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning',
        }
      )
        .then(() => {
          this.is_delete_loading = true;
          serverAddr
            .delete(`/recommendation/admin/v1/equity_delete_reco/${data.id}`, {
              data: {},
            })
            .then(() => {
              this.$message.success('Reco deleted successfully.');
              this.getEquityRecolist();
            })
            .catch(() => {
              this.$message.error('Failed to delete reco.');
            })
            .finally(() => {
              this.is_delete_loading = false;
            });
        })
        .catch(() => {

        });
    },

    // Method for Delete Strategy
    deleteOptionStrategy(data) {
      const strategyName = data.title || 'this strategy';

      this.$confirm(
        `Are you sure you want to delete the strategy for "${strategyName}"?`,
        'Confirm Delete',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning',
        }
      )
        .then(() => {
          this.is_delete_loading = true;

          serverAddr
            .delete(`/options/admin/v1/delete/strategy/${data.id}`, {
              data: {},
            })
            .then(() => {
              this.$message.success('Strategy deleted successfully.');
              this.getOptionsRecoList(); // Refresh list method
            })
            .catch(() => {
              this.$message.error('Failed to delete strategy.');
            })
            .finally(() => {
              this.is_delete_loading = false;
            });
        })
        .catch(() => {
          // Cancelled by user
        });
    },

    // For broker recommendations pagination
    handleBrokersPageChange(val) {
      this.currentPageBrokers = val;
      this.getOptionsRecoList();
    },

    getOptionsRecoList() {
      this.is_broker_reco_list_loading = true;

      // Combine selected filters from all checkbox groups into a single array
      const filters = [...this.strategyType, ...this.strategyStatus];

      const requestPayload = {
        page_number: this.currentPageBrokers,
        page_per_entries: this.paginationBrokers.page_size,
        expert_list: this.selectedExpert ? [this.selectedExpert] : [],
        company_id_list: [],
        filters: filters,
        profession_list: this.marketExperts,
        stock_id: this.stockId,
        start_date: this.start_date,
        end_date: this.end_date,
      };

      serverAddr
        .post("/options/admin/v2/option_dashboard", requestPayload)
        .then((response) => {
          if (response.data.status) {
            this.brokersRecoList = response.data.data || [];
            this.paginationBrokers = {
              total_entries: response.data.pagination.total_entries || 0,
              current_page: response.data.pagination.current_page || 1,
              page_size: response.data.pagination.page_size || 10,
            };
          } else {
            this.brokersRecoList = [];
            this.resetPaginationBrokers();
          }
          this.is_broker_reco_list_loading = false;
        })
        .catch((error) => {
          console.error("Error fetching broker recommendations:", error);
          this.brokersRecoList = [];
          this.resetPaginationBrokers();
          this.is_broker_reco_list_loading = false;
        });
    },

    resetPaginationBrokers() {
      this.paginationBrokers = {
        total_entries: 0,
        current_page: 1,
        page_size: 10,
      };
    },

    // Below code for options recommendations export
    getOptionsRecommendationsForExport() {
      this.is_options_export_loading = true;

      // Step 1: Get total entries
      serverAddr
        .post('/options/admin/v2/option_dashboard', {
          page_number: 1,
          page_per_entries: 1,
          start_date: this.start_date,
          end_date: this.end_date
        })
        .then((countRes) => {
          if (countRes.data.status) {
            const totalEntries = countRes.data.pagination.total_entries;

            // Step 2: Fetch all entries at once
            return serverAddr.post('/options/admin/v2/option_dashboard', {
              page_number: 1,
              page_per_entries: totalEntries,
              start_date: this.start_date,
              end_date: this.end_date
            });
          } else {
            throw new Error("Failed to get total entries");
          }
        })
        .then((exportRes) => {
          if (exportRes.data.status) {
            this.exportOptionsList = exportRes.data.data;
            this.downloadOptionsExcel();
          } else {
            this.is_options_export_loading = false;
          }
        })
        .catch((error) => {
          console.error("Export error:", error);
          this.is_options_export_loading = false;
        });
    },

    async downloadOptionsExcel() {
      try {
        this.is_options_export_loading = true;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("OptionsReco");

        const headers = [
          "S.No",
          "Strategy ID",
          "Opinion ID",
          "Strategy Date",
          "Strategy Name",
          "Direction",
          "Tag",
          "Status",
          "Entry Price",
          "Performance",
          "CMP",
          "Strike Price",
          "Remaining Target",
          "Capital Required",
          "Target",
          "SL",
          "Risk",
          "Expert Name",
          "SEBI No."
        ];
        worksheet.addRow(headers);

        let serial = 1;

        this.exportOptionsList.forEach(function (strategy) {
          if (Array.isArray(strategy.legs_data)) {
            strategy.legs_data.forEach(function (leg) {
              worksheet.addRow([
                serial++,
                strategy.id != null ? strategy.id : "NA",   // Strategy ID
                leg.id != null ? leg.id : "NA",               // Opinion ID
                strategy.created_date_str
                  ? moment(strategy.created_date_str).format("MMM DD YYYY, h:mm A")
                  : "NA",
                strategy.title ? strategy.title : "NA",
                leg.direction ? leg.direction : "NA",
                strategy.tags ? strategy.tags : "NA",
                leg.status ? leg.status.replace(/_/g, " ") : "NA",
                leg.entry_premium != null ? leg.entry_premium : "NA",
                leg.performance != null ? leg.performance + "%" : "NA",
                leg.stock_data && leg.stock_data.ltp != null ? leg.stock_data.ltp : "NA",
                leg.stock_data && leg.stock_data.strike != null ? leg.stock_data.strike : "NA",
                leg.remaining_target_in_perc != null ? leg.remaining_target_in_perc + "%" : "NA",
                strategy.required_total_margin != null ? strategy.required_total_margin : "NA",
                leg.target_premium != null ? leg.target_premium : "NA",
                leg.stop_loss != null ? leg.stop_loss : "NA",
                strategy.risk_tags ? strategy.risk_tags : "NA",
                strategy.expert_detail && strategy.expert_detail.full_name
                  ? strategy.expert_detail.full_name
                  : "NA",
                strategy.expert_detail && strategy.expert_detail.sebi_regi_number
                  ? strategy.expert_detail.sebi_regi_number
                  : "NA"
              ]);
            });
          }
        });

        worksheet.columns.forEach(function (column) {
          column.width = 20;
        });


        worksheet.views = [{ state: "frozen", ySplit: 1 }];

        /* == SHEET 2 : STRATEGY WISE (WITH ID) == */
        const strategySheet = workbook.addWorksheet("StrategySummary");

        const strategyHeaders = [
          "S.No",
          "Strategy ID",
          "Strategy Date",
          "Strategy Name",
          "Status",
          "Avg Performance %",
          "Expert Name"
        ];
        strategySheet.addRow(strategyHeaders);

        let strategySerial = 1;

        this.exportOptionsList.forEach((strategy) => {
          strategySheet.addRow([
            strategySerial++,
            strategy.id != null ? strategy.id : "NA",
            strategy.created_date_str
              ? moment(strategy.created_date_str).format("MMM DD YYYY, h:mm A")
              : "NA",
            strategy.title ? strategy.title : "NA",
            strategy.status ? strategy.status : "NA",
            strategy.avg_performance != null
              ? strategy.avg_performance + "%"
              : "NA",
            strategy.expert_detail && strategy.expert_detail.full_name
              ? strategy.expert_detail.full_name
              : "NA"
          ]);
        });

        strategySheet.columns.forEach((column) => {
          column.width = 22;
        });

        strategySheet.views = [{ state: "frozen", ySplit: 1 }];

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "Options_Recommendation_" + moment().format("YYYYMMDD_HHmmss") + ".xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

      } catch (error) {
        console.error("Download Excel error:", error);
      } finally {
        this.is_options_export_loading = false;
      }
    },

    // Perform an action when clicking the button
    performAction(data) {
      console.log("Action performed for:", data);
    },

    // filter data
    resetFilter() {
      this.active_index_title = null;
      this.marketParticipants = [];
      this.marketExperts = [];
      this.recommendationType = [];
      this.strategyType = [];
      this.marketCap = [];
      this.recommendationStatus = [];
      this.strategyStatus = [];
      this.targetPeriodType = null;
    },
  },

  computed: {
    filteredTelegramBrokers() {
      if (!this.brokerSearch) {
        return this.brokerList
      }

      return this.brokerList.filter(broker =>
        broker.title
          .toLowerCase()
          .includes(this.brokerSearch.toLowerCase())
      )
    },
    // For Equity section date picker
    startDatePickerOptions() {
      return {
        disabledDate: (time) => {
          const now = new Date();
          if (this.to) {
            return time.getTime() > now.getTime() || time.getTime() > new Date(this.to).getTime();
          }
          return time.getTime() > now.getTime();
        },
      };
    },

    endDatePickerOptions() {
      return {
        disabledDate: (time) => {
          const now = new Date();
          if (this.from) {
            return time.getTime() < new Date(this.from).getTime() || time.getTime() > now.getTime();
          }
          return time.getTime() > now.getTime();
        },
      };
    },

    sortedUsersList() {
      // Sort subscribedUsersList based on user_last_login and sortOrder
      return this.subscribedUsersList.slice().sort((a, b) => {
        const dateA = moment(a.user_last_login);
        const dateB = moment(b.user_last_login);

        if (this.sortOrder === "asc") {
          return dateA - dateB;
        } else {
          return dateB - dateA;
        }
      });
    },
    selected_broker() {
      return this.$store.state.selected_broker
        ? this.$store.state.selected_broker
        : null;
    },

    //returns stored user profile from local storage
    userProfile() {
      return JSON.parse(localStorage.getItem("profile"));
    },

    // return user details
    user_details() {
      return this.$store.state.user_details;
    },

    //returns subscribed plan details from local storage
    subscribedPlanDetails() {
      return JSON.parse(localStorage.getItem("plan_details"));
    },

    isStockAntsAdmin() {
      const roles = JSON.parse(localStorage.getItem("userRoles")) || [];
      return roles.includes("StockAnts Admin");
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";

.SADashboardAnalytics {
  min-height: calc(100vh - 60px);
  background-color: $page-background-color;
  padding: 60px 0 0 0;


  .market-type-dropdown {
    display: flex;
    width: calc(100% - 285px);
    justify-content: space-between;
    align-items: center;
    margin-left: 285px;


    .input-label-bold-gray {
      margin-top: 0;
    }

    .date-filter-section {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      width: 100%;
    }

    .export-btn {
      font-size: 12px;
      padding: 4px 10px;
      margin-left: 8px;
    }

    .reset-btn {
      border-radius: 15px;
      padding: 3px 10px;
      color: rgb(64, 158, 255);
      border-color: rgb(64, 158, 255);
    }
  }

  .outer {
    background-color: #feffe5;
    text-align: center;
    padding: 10px 0px 20px;
    width: calc(100% - 265px);
    margin-left: 265px;
  }

  .cover-page-container {
    .export-btn {
      font-size: 12px;
      padding: 4px 10px;
      margin-left: 8px;
    }

    .board-table-outer {
      border-top: 4px solid #bea66e;
      overflow-x: auto;
      min-height: auto;

      .live {
        color: #079e3e;
      }

      .expired {
        color: #e72726;
      }

      .download-btn {
        padding: 5px 8px;
        font-size: 12px;
        width: 15px;
        margin: 0 auto;
        box-shadow: 0px 1px 3px 1px #e0e0e0;
      }

      .sub-section {
        padding: 0 !important;
      }

      .sub-sec-head {
        width: 100%;
        text-align: left;
        background-color: #2d2e8d;
        padding: 10px;
        color: #ffff;
        margin: 10px 0 0;
        font-weight: 600;
      }
    }

    .center-content {
      text-align: center;
      vertical-align: middle;
    }

    .board-table {
      overflow-x: auto;
      border-spacing: 0;
      border-collapse: collapse;
      width: 100%;
      text-align: left;

      .main-head th {
        color: #000;
      }

      .border-right-gray {
        border-right: 1px solid #e9e9e9;
      }

      .border-bottom-gray {
        border-bottom: 1px solid #e9e9e9;
      }

      .bottom-spacing-table-heading {
        padding: 0px 8px 8px 8px;
      }

      thead {
        tr {
          th {
            color: #a5a6a8;
            font-size: 0.8rem;
            font-weight: 700;
            padding: 10px 10px;
            white-space: normal;
            word-break: break-word;
            overflow-wrap: break-word;
          }
        }

        tr:nth-child(1) {
          border-bottom: 1px solid #e9e9e9;
          background-color: #ededed;
        }
      }

      .tags {
        width: auto;
        align-items: center;
        margin-top: 10px;
        padding: 5px 10px 5px 10px;
        text-transform: capitalize;
        font-size: 14px;
        font-weight: 500px;
        border-radius: 15px;
        background-color: #dbffe8;
        color: #0ba042;
      }

      .truncate {
        max-width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      tbody {

        // min-height: 300px;
        tr {
          td {
            font-size: 0.7rem;
            font-weight: 500;
            padding: 10px 10px;
            border-bottom: 1px solid #ddd;
          }
        }
      }

      td.fixed-column,
      th.fixed-column {
        position: sticky;
        right: -1px;
        z-index: 1;
        background-color: #ffff;
        border-bottom: none;
        height: 23px;
        border-bottom: 1px solid #ddd !important;
        box-shadow: -4px 1px 5px -3px #00000080;
        margin: 0;
        padding: 8px;
      }
    }

    .el-range-editor.el-input__inner {
      margin-right: 20px;
    }

    .pagination {
      margin: 15px 0 10px;
    }

    .user-details-section {
      border-bottom: 1px solid #d5d5d5;
      padding: 10px 20px;
    }

    .crown-outer {
      background: #bea66e;
      padding: 2px 5px;
      border-radius: 5px;
      margin-right: 3px;
    }

    .filter-section {
      padding: 0 20px;
      margin-bottom: 15px;
    }
  }

  .cover-page-container {
    width: calc(100% - 285px);
    margin-left: 285px;
    margin-top: 15px;
    padding-bottom: 10px;
    box-sizing: border-box;
    background-color: #fff;
    box-shadow: 0px 10px 7px 1px #dcd6d6;
    margin-bottom: 50px;
  }

  .footer-section {
    width: calc(100% - 260px);
    margin-left: 260px;
  }

  @media screen and (max-width: 1283px) {

    .cover-page-container,
    .footer-section {
      width: 100%;
      margin-left: 0;
      height: auto;
      margin-top: 15px;
    }

    .sideBarSection {
      display: none;
    }
  }

  .custom-popover {
    padding: 0;
  }

  .popover-content {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    /* Ensures divs take full width */
  }

  .popover-item {
    padding: 10px;
    cursor: pointer;
    white-space: nowrap;
    display: flex;
    align-items: center;
  }

  .popover-item:hover {
    background-color: #f5f7fa;
  }

  .popover-item i {
    margin-right: 5px;
  }

  /* Dialog Box Styling */
  .custom-dialog {
    border-radius: 12px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    padding: 20px;
  }

  /* Reco ID Styling */
  .reco-id {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 10px;
  }

  /* Status Title */
  .status-title {
    font-size: 18px;
    font-weight: bold;
    color: #444;
    margin-bottom: 10px;
    border-bottom: 2px solid #ddd;
    padding-bottom: 5px;
  }

  /* Status Row Styling */
  .status-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
  }

  /* Status Label */
  .status-label {
    font-size: 14px;
    font-weight: 500;
    color: #555;
    min-width: 150px;
  }

  /* Select Box */
  .status-select {
    width: 100%;
    margin-bottom: 15px;
  }

  /* Input Fields */
  .el-input,
  .el-date-picker {
    width: 100%;
  }

  /* Dialog Footer */
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }

  /* Button Styling */
  .cancel-btn {
    background-color: #f5f5f5;
    color: #333;
    border: 1px solid #ddd;
    font-size: 14px;
    padding: 8px 16px;
  }

  .save-btn {
    background-color: #409eff;
    color: white;
    font-size: 14px;
    padding: 8px 16px;
    border-radius: 4px;
  }
}
</style>

<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.SADashboardAnalytics {
  .NoDataFound {
    padding: 15px 0 0 0;
  }

  .review-card {
    border-radius: 10px;

    .el-card__body {
      padding: 5px 20px;
    }
  }

  .analytics-card {
    border-radius: 10px;
  }

  .review-section,
  .user-access-section {
    .el-rate__icon {
      font-size: 14px !important;
      margin-right: 2px;
    }
  }

  .referal-dialog {
    .el-dialog__header .el-dialog__title {
      color: #000;
      font-weight: 500;
    }
  }

  @media screen and (max-width: 992px) {
    .referal-dialog {
      width: 80% !important;
    }
  }
}

// Below css for user login & device details dialog box of
.custom-dialog .el-dialog__header {
  background-color: #f5f5f5;
  border-bottom: 1px solid #ebeef5;
  padding: 20px;
}

.custom-dialog .el-dialog__body {
  padding: 20px;
}

.custom-dialog .el-dialog__footer {
  border-top: 1px solid #ebeef5;
}

.custom-dialog .el-dialog {
  border-radius: 10px;
  overflow: hidden;
}

.custom-dialog .el-table {
  width: 100%;
}

.custom-dialog .el-table th {
  text-align: left;
  padding: 10;
}

.custom-dialog .el-table td {
  text-align: left;
  padding: 0;
}

.custom-dialog .el-dialog__wrapper {
  background-color: rgba(0, 0, 0, 0.5);
}

.custom-dialog {
  width: 100%;
}

// Below css for right click functionality
.context-menu {
  position: absolute;
  z-index: 1000;
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.context-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.context-menu li {
  padding: 8px 12px;
  cursor: pointer;
}

.context-menu li:hover {
  background-color: #f5f5f5;
}

.input-container {
  position: relative;
  width: 300px;
  margin-left: 15px;
}

.search-input {
  width: 220px;
  padding: 10px;
  padding-right: 30px;
  /* space for the icon */
  font-size: 14px;
  border: 1px solid #dcdcdc;
  border-radius: 20px;
  outline: none;
}

.search-input:focus {
  border-color: #409eff;
  /* blue border on focus */
}

.search-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  margin-top: 12px;
  transform: translateY(-50%);
  cursor: pointer;
}

.search-icon {
  width: 16px;
  height: 16px;
}

// filter css below

.FilterForDesktopView {
  width: 280px;
  -webkit-box-shadow: 10px 0 10px -5px #d3d3d3;
  box-shadow: 10px 0 10px -5px #d3d3d3;
  position: fixed;
  height: 100%;
  overflow: auto;
  background-color: $filter-section-background-color;
}

.FilterForDesktopView .filter-section {
  background-color: #f7f8fc;
}

.FilterForDesktopView .filter-section-title {
  display: flex;
  justify-content: space-around;
  font-weight: 500;
  padding: 25px 0;
}

.FilterForDesktopView .filter-header {
  padding-top: 20px;

  div {
    text-align: center;
    border-radius: 20px;
    border: 1px solid #000;
    font-size: 0.8rem;
    font-weight: 600;
    color: #000;
    padding: 5px 20px;
    width: fit-content;
    margin: 0 auto;
  }
}

.FilterForDesktopView .border-bottom:after {
  position: absolute;
  bottom: -30px;
  left: 13px;
  width: 22px;
  height: 2px;
  margin-bottom: 25px;
  content: "";
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  background-color: $primary-theme-color;
}

.filter-toggle-content {
  padding: 15px 20px;
  border-bottom: 1px solid #ddd;
}

.FilterForDesktopView .filter-title {
  font-size: 0.8rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  .el-icon-plus,
  .el-icon-minus {
    font-size: 0.5rem;
    font-weight: 600;
  }
}

.FilterForDesktopView .disabled {
  color: #9c9999;
}

.filter-tab {
  display: block;
  margin-top: 10px;
}

.FilterForDesktopView .active-menu-bgColor {
  background: $filter-section-background-color;
}

// filters input type css start
.FilterForDesktopView .el-input--small .el-input__inner {
  border-radius: 25px !important;
  background: transparent !important;
  border-color: #797979 !important;
  color: #797979;
}

.FilterForDesktopView .el-radio__label {
  color: black;
  font-size: 0.8rem;
  font-weight: 400;
}

.FilterForDesktopView .el-input__inner::placeholder {
  color: #89898a;
}

.FilterForDesktopView .el-select .el-input .el-select__caret {
  /* Internet Explorer */
  color: #89898a;
}

.FilterForDesktopView .el-checkbox__inner {
  background-color: #dcdfe6;
}

.FilterForDesktopView .el-checkbox__label {
  text-transform: capitalize;
  font-size: 13px;
  color: #000;
  font-weight: 400;
}

.FilterForDesktopView .range-dropdown {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.FilterForDesktopView .range-dropdown small {
  width: 30px;
  text-align: right;
  margin-right: 10px;
}

.FilterForDesktopView .range-dropdown .el-input--mini .el-input__inner {
  border-radius: 5px !important;
  max-width: 95px;
  border-color: #797979;
  background: transparent;
}

// scroll bar css start
#scroll::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

#scroll::-webkit-scrollbar {
  width: 5px;
  background-color: #f5f5f5;
}

#scroll::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: lightgrey;
}

.telegram-broker-dialog {

  .el-dialog {
    width: 380px !important;
    border-radius: 12px;
    margin-top: 30px !important;
  }

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 20px;
    overflow: hidden;
  }

  .broker-card-main {
    text-align: center;
  }

  /* Logo */
  .logo {
    width: 180px;
  }

  /* Search */
  .search-broker-input {
    width: 92%;
    margin: 0 auto 18px;

    .el-input__inner {
      border-radius: 20px;
      font-size: 12px;
      height: 32px;
    }
  }

  /* Scroll area */
  .broker-card-outer {
    max-height: 220px;
    overflow-y: auto;

    .broker-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
    }
  }

  /* Scrollbar */
  .broker-card-outer::-webkit-scrollbar {
    width: 2px;
  }

  .broker-card-outer::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.25);
    border-radius: 10px;
  }

  .broker-card {
    background: #ffffff;
    border-radius: 8px;
    height: 30px;
    padding: 10px;
    margin: 10px;
    cursor: pointer;
    box-shadow: 0 2px 10px 0 rgba(9, 9, 9, .2784313725);
    border: 1px solid transparent;
    transition: all 0.2s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow:
        0 4px 10px rgba(0, 0, 0, 0.12);
    }

    &.active {
      border-color: #2d2e8d;
      background: #f4f6ff;
    }
  }

  .broker-content {
    display: flex;
    align-items: center;
    height: 100%;
  }

  .broker-logo {
    padding: 0px;
  }

  .broker-title {
    margin-left: 12px;
    font-size: 12px;
    font-weight: 600;
    color: #606266;
    text-align: left;
    word-break: normal;
  }

  .hidden-checkbox {
    display: none;
  }

  /* Footer */
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin: 10px 10px 0px 10px;
  }
}
</style>
